// =====================================
//
//   針對產品可以選擇 Controller
//   Author: Alan
//   createtime: 2016 / 02 / 25
//   Author: Gray copy form web
//   updatetime: 2016 / 09 / 05
//
// =====================================

window.InifECMobileApp.controller("PdtSpecController", ['$rootScope', '$scope', '$state', '$stateParams', '$q', '$ngModal', 'ShoppingCartService', '$element', '$timeout', '$InifECGA', '$filter', 'UserService', 'ProcessPriceService', 'ProductDeliveryService', 'ProductUtil',
    function($rootScope, $scope, $state, $stateParams, $q, $ngModal, ShoppingCartService, $element, $timeout, $InifECGA, $filter, UserService, ProcessPriceService, ProductDeliveryService, ProductUtil) 
    {
        var PriceRuleType = ProductUtil.PriceRuleType; // 商品價格計算規則型態
        var PdtSpecProps = ProductUtil.PdtSpecProps; // 商品規格所有欄位
        var ProductidKey = "productid"; // 規格id key
        var SpecidKey = "specid"; // 規格id key
        var DimensionKey = "dimension"; // 尺寸key
        var CountKey = "count"; // 數量key
        var OneTwoSideKey = "oneTwoSide"; // 單面選項key
        var ProcessKey = "process"; // 加工選項key
        var OfferProcessKey = "offerProcess"; // 特殊加工選項key
        var ImageDimensionKey = "imageDimension"; // 印刷尺寸 key
        var CountMaxMultiple = 50;
        var CountLayoutType = {
            Options: 1, // 選單
            Custom: 2, // 輸入框
            ClothinghSize: 3, // 尺碼與件數
        }

        // 各個欄位索引的位置
        var SpecPropsIndex = {
            [ProductidKey]: 0,
            [SpecidKey]: 1,
            [PdtSpecProps.MaterialType]: 2,
            [PdtSpecProps.PdtStyle]: 3,
            [PdtSpecProps.SleeveLength]: 4,
            [DimensionKey]: 5, // 含 PdtSpecProps.Length, PdtSpecProps.Width, PdtSpecProps.Height, PdtSpecProps.SizeRemark
            [PdtSpecProps.ColorHex]: 6,
            [PdtSpecProps.Version]: 7,
            [PdtSpecProps.AreaRange]: 8,
            [PdtSpecProps.Thickness]: 9,
            [PdtSpecProps.Volume]: 10,
            [PdtSpecProps.Dpi]: 11,
            [PdtSpecProps.Bronzing]: 12,
            [ImageDimensionKey]: 13, // 含 PdtSpecProps.ImageLength, PdtSpecProps.ImageWidth, PdtSpecProps.ImageSizeRemark
        };

        // ------------------------------
        // 攤平所有規格
        // ------------------------------
        var initSpec = function(defaultSpecForm) {

            var productList = undefined;

            if($scope.complex && $scope.complex.productList && $scope.complex.productList.length > 0) {
                productList = $scope.complex.productList;
            } else {
                productList = [];
                productList.push($scope.product);
            }

            $scope.productMap = {};
            $scope.specMap = {};
            $scope.specMatrix.length = 0;

            for(var p = 0; p < productList.length; p++) {
                var product = productList[p];
                var specs = checkProductSpecs(product);
                var size = specs.length;

                for(var i = 0; i < size; i++) {

                    var spec = specs[i];

                    // 將出貨時間format為x日
                    if(!window.isNaN(spec.deliveryDate) && spec.deliveryDate >= spec.deliveryDateUnit.time) {
                        spec.deliveryTime = spec.deliveryDate / spec.deliveryDateUnit.time;
                    }

                    var productid = product.productid;
                    var specid = spec.specid;
                    var specProps = spec.specProps;
                    var specList = [];

                    specList[SpecPropsIndex[ProductidKey]] = productid;
                    specList[SpecPropsIndex[SpecidKey]] = specid;

                    if(isProductPropSupport(product, PdtSpecProps.Length) || isProductPropSupport(product, PdtSpecProps.Width) ||
                        isProductPropSupport(product, PdtSpecProps.Height) || isProductPropSupport(product, PdtSpecProps.SizeRemark)
                    ) {
                        var dimension = {};
                        var hasDimension = false;

                        if(isProductPropSupport(product, PdtSpecProps.Length) && specProps[PdtSpecProps.Length]) {
                            dimension[PdtSpecProps.Length] = specProps[PdtSpecProps.Length];
                            hasDimension = true;
                        }

                        if(isProductPropSupport(product, PdtSpecProps.Width) && specProps[PdtSpecProps.Width]) {
                            dimension[PdtSpecProps.Width] = specProps[PdtSpecProps.Width];
                            hasDimension = true;
                        }

                        if(isProductPropSupport(product, PdtSpecProps.Height) && specProps[PdtSpecProps.Height]) {
                            dimension[PdtSpecProps.Height] = specProps[PdtSpecProps.Height];
                            hasDimension = true;
                        }

                        if(isProductPropSupport(product, PdtSpecProps.SizeRemark) && specProps[PdtSpecProps.SizeRemark]) {
                            dimension[PdtSpecProps.SizeRemark] = specProps[PdtSpecProps.SizeRemark];
                            hasDimension = true;
                        }

                        if(hasDimension) {
                            specList[SpecPropsIndex[DimensionKey]] = dimension;
                        }
                    }

                    // 樣式
                    if(isProductPropSupport(product, PdtSpecProps.PdtStyle) && specProps[PdtSpecProps.PdtStyle]) {
                        specList[SpecPropsIndex[PdtSpecProps.PdtStyle]] = specProps[PdtSpecProps.PdtStyle];
                    }

                    // 材質
                    if(isProductPropSupport(product, PdtSpecProps.MaterialType) && specProps[PdtSpecProps.MaterialType]) {
                        specList[SpecPropsIndex[PdtSpecProps.MaterialType]] = specProps[PdtSpecProps.MaterialType];
                    }

                    // 版型
                    if(isProductPropSupport(product, PdtSpecProps.Version) && specProps[PdtSpecProps.Version]) {
                        specList[SpecPropsIndex[PdtSpecProps.Version]] = specProps[PdtSpecProps.Version];
                    }

                    // 面積範圍
                    if(isProductPropSupport(product, PdtSpecProps.AreaRange) && specProps[PdtSpecProps.AreaRange]) {
                        specList[SpecPropsIndex[PdtSpecProps.AreaRange]] = specProps[PdtSpecProps.AreaRange];
                    }

                    // 厚度
                    if(isProductPropSupport(product, PdtSpecProps.Thickness) && specProps[PdtSpecProps.Thickness]) {
                        specList[SpecPropsIndex[PdtSpecProps.Thickness]] = specProps[PdtSpecProps.Thickness];
                    }

                    // 容量
                    if(isProductPropSupport(product, PdtSpecProps.Volume) && specProps[PdtSpecProps.Volume]) {
                        specList[SpecPropsIndex[PdtSpecProps.Volume]] = specProps[PdtSpecProps.Volume];
                    }

                    // 解析度
                    if(isProductPropSupport(product, PdtSpecProps.Dpi) && specProps[PdtSpecProps.Dpi]) {
                        specList[SpecPropsIndex[PdtSpecProps.Dpi]] = specProps[PdtSpecProps.Dpi];
                    }

                    // 燙金
                    if(isProductPropSupport(product, PdtSpecProps.Bronzing) && specProps[PdtSpecProps.Bronzing]) {
                        // @see ProductUtil.PdtBronzingInfo
                        var pdtBronzingInfo = specProps[PdtSpecProps.Bronzing];

                        specList[SpecPropsIndex[PdtSpecProps.Bronzing]] = pdtBronzingInfo;;
                    }

                    // 袖長
                    if(isProductPropSupport(product, PdtSpecProps.SleeveLength) && specProps[PdtSpecProps.SleeveLength]) {
                        specList[SpecPropsIndex[PdtSpecProps.SleeveLength]] = specProps[PdtSpecProps.SleeveLength];
                    }

                    // 因為規格內的衣服尺寸是列表，所以要再把它攤平
                    var moreSpecSize = 1;
                    var all_colorHexList = [];

                    // 顏色
                    if(isProductPropSupport(product, PdtSpecProps.ColorHexList) && specProps[PdtSpecProps.ColorHexList]) {
                        var colorHexList = specProps[PdtSpecProps.ColorHexList];

                        if(Array.isArray(colorHexList) && colorHexList.length > 0) {
                            moreSpecSize = moreSpecSize * colorHexList.length;

                            for(var j = 0; j < colorHexList.length; j++) {
                                // @see ProductUtil.PdtColorInfo
                                var pdtColorHexInfo = colorHexList[j];

                                all_colorHexList.push(pdtColorHexInfo);
                            }
                        }
                    }

                    if(isProductPropSupport(product, PdtSpecProps.ImageLength) || isProductPropSupport(product, PdtSpecProps.ImageWidth) ||
                        isProductPropSupport(product, PdtSpecProps.ImageSizeRemark)
                    ) {
                        var imageDimension = {};
                        var hasImageDimension = false;

                        if(isProductPropSupport(product, PdtSpecProps.ImageLength) && specProps[PdtSpecProps.ImageLength]) {
                            imageDimension[PdtSpecProps.ImageLength] = specProps[PdtSpecProps.ImageLength];
                            hasImageDimension = true;
                        }

                        if(isProductPropSupport(product, PdtSpecProps.ImageWidth) && specProps[PdtSpecProps.ImageWidth]) {
                            imageDimension[PdtSpecProps.ImageWidth] = specProps[PdtSpecProps.ImageWidth];
                            hasImageDimension = true;
                        }

                        if(isProductPropSupport(product, PdtSpecProps.ImageSizeRemark) && specProps[PdtSpecProps.ImageSizeRemark]) {
                            imageDimension[PdtSpecProps.ImageSizeRemark] = specProps[PdtSpecProps.ImageSizeRemark];
                            hasImageDimension = true;
                        }

                        if(hasImageDimension) {
                            specList[SpecPropsIndex[ImageDimensionKey]] = imageDimension;
                        }
                    }
                    
                    var chooseList = [];

                    chooseList.push(all_colorHexList.length);

                    for(var j = 0; j < moreSpecSize; j++) {
                        var combination = chooseCombination(j, chooseList);
                        var _specList = specList.slice();
                        var colorHex = all_colorHexList[combination[0]];

                        if(colorHex) {
                            _specList[SpecPropsIndex[PdtSpecProps.ColorHex]] = colorHex;                            
                        }

                        $scope.specMatrix.push(_specList);
                    }

                    // 建立規格Map 方便之後以id找到規格資訊
                    if(!$scope.specMap[productid]) {
                        $scope.specMap[productid] = {};
                    }

                    $scope.specMap[productid][specid] = spec;

                    // 建立商品Map 方便之後以id切換複合商品
                    $scope.productMap[productid] = product;
                }
            }

            filterSpec(true, defaultSpecForm); // 過濾規格，並設出始值
        }

        // ------------------------------
        // 初始化供應商列表
        // ------------------------------
        var initSupplier = function(product, form) {

            form.supplier = product.supplierList[0];

            for(var i = 0; i < product.supplierList.length; i++) {

                if(product.supplierList[i] == 'topcolor') {
                    form.supplier = product.supplierList[i];
                    break;
                }
            }
        }

        // ------------------------------
        // 初始化配件商品內的規格，並攤平
        // 
        // 而配件目前只會顯示樣式的規格，算是極簡易版 initSpec
        // ------------------------------
        var initAccessorySpec = function(_accessoryList) {

            var accessoryList = [];

            for(var p = 0; p < _accessoryList.length; p++) {
                var accessory = _accessoryList[p];
                var specs = accessory.specs;
                var size = specs.length;
                var spec = specs[0];

                for(var j = 0; j < size; j++) {
                    var spec = specs[j];
                    // 將出貨時間format為x日
                    if(!window.isNaN(spec.deliveryDate) && spec.deliveryDate >= spec.deliveryDateUnit.time) {
                        spec.deliveryTime = spec.deliveryDate / spec.deliveryDateUnit.time;
                    }
                }

                accessory.spec = spec;
                accessory.form = {
                    count: spec.countList[0],
                };

                initSupplier(accessory, accessory.form); // 初始化配件供應商
                initAccessoryCountList(accessory); // 初始化配件數量選項
                refreshAccessoryPrice(accessory); // 計算配件價格
                accessory.isAccessorySelected = false; // 將配件都設為未選取

                accessoryList.push(accessory);
            }

            $scope.accessoryList = accessoryList;
        }

        // ------------------------------
        // 檢查所有規格裡是否有要重新排序的
        // ------------------------------
        var checkProductSpecs = function(product) {

            var specs = product.specs;

            if(!Array.isArray(specs) || specs.length === 0) {
                return specs;
            }

            var hasPrintingTypeList = isProductPropSupport(product, PdtSpecProps.PrintingTypeList);

            if(hasPrintingTypeList) {

                for(var i = 0; i < specs.length; i++) {
                    var spec = specs[i];
                    var specProps = spec.specProps;

                    if(!specProps) {
                        continue;
                    }

                    var printingTypeList = specProps[PdtSpecProps.PrintingTypeList];
                    if(Array.isArray(printingTypeList) && printingTypeList.length > 0) {
                        specProps[PdtSpecProps.PrintingTypeList] = printingTypeList.sort(function(a, b) { return b - a; });
                    }
                }
            }

            return specs;
        }

        // ------------------------------
        // 檢查商品是否提供該規格
        // ------------------------------
        var isProductPropSupport = function(product, prop) {

            var supportProps = product.supportProps;

            return supportProps.indexOf(prop) !== -1;
        }
        
        // ------------------------------
        // 取得全部組合中的第 n 種
        // 
        // EX:  假設選項有 A: 3種, B: 4種, C: 2種
        //      總共有 3 * 4 * 2 = 24 種組合
        //      第 1 種的組合解為 A 的第 1 種, B 的第 1 種, C 的第 1 種 
        //      第 17 種的組合解為 A 的第 3 種, B 的第 2 種, C 的第 2 種  
        // 
        // 但因應 code 陣列的特性, 陣列是由 0 開始數起, 因此上面範例的回傳結果為
        // EX:  第 1 種的回傳 [0, 0, 0]
        //      第 17 種的回傳 [2, 1, 1]
        //
        // ------------------------------
        var chooseCombination = function(index, chooseList) {

            var combinations = []; // 組合結果
            var divisor; // 除數
            var dividend; // 被除數
            var quotient; // 商
            var remainder; // 餘數

            divisor = index;

            for(var i = 0; i < chooseList.length; i++) {

                dividend = chooseList[i];

                if(dividend === undefined || dividend === 0) {
                    remainder = -1; // 選項為無
                } else {
                    quotient = Math.floor(divisor / dividend);
                    remainder = divisor % dividend;

                    divisor = quotient;
                }

                combinations.push(remainder);
            }

            return combinations;
        }

        // ------------------------------
        // [SCOPE] 是否提供該規格
        // ------------------------------
        var isPropSupport = function(prop) {

            return isProductPropSupport($scope.product, prop);
        }

        // ------------------------------
        // 過濾 SpecMatrix
        // ------------------------------
        var filterSpec = function(isInit, defaultSpecForm) {

            var selectResult = undefined,
                filterMatrix = $scope.specMatrix,
                selectListMap = {};
            
            if(isInit) {
                // 第一次載入時，若有傳入訂單規格，則合併至form
                if(defaultSpecForm, defaultSpecForm[SpecidKey]) {
                    $scope.form = Object.assign({}, $scope.form, defaultSpecForm);
                } else { // 若無，則用第一個商品規格，將有建立索引的欄位補上預設值 (這邊是避免複合商品頁面重整選錯資料)
                    var firstSpec = $scope.product.specs[0];
                    var firstSpecProps = firstSpec.specProps;

                    var dimension = {};
                    var hasDimension = false;

                    if(firstSpecProps[PdtSpecProps.Length]) {
                        dimension[PdtSpecProps.Length] = firstSpecProps[PdtSpecProps.Length];
                        hasDimension = true;
                    }

                    if(firstSpecProps[PdtSpecProps.Width]) {
                        dimension[PdtSpecProps.Width] = firstSpecProps[PdtSpecProps.Width];
                        hasDimension = true;
                    }

                    if(firstSpecProps[PdtSpecProps.Height]) {
                        dimension[PdtSpecProps.Height] = firstSpecProps[PdtSpecProps.Height];
                        hasDimension = true;
                    }

                    if(firstSpecProps[PdtSpecProps.SizeRemark]) {
                        dimension[PdtSpecProps.SizeRemark] = firstSpecProps[PdtSpecProps.SizeRemark];
                        hasDimension = true;
                    }

                    if(hasDimension) {
                        $scope.form[DimensionKey] = dimension;
                    }

                    if(firstSpecProps[PdtSpecProps.MaterialType]) {
                        $scope.form[PdtSpecProps.MaterialType] = firstSpecProps[PdtSpecProps.MaterialType];
                    }

                    if(firstSpecProps[PdtSpecProps.PdtStyle]) {
                        $scope.form[PdtSpecProps.PdtStyle] = firstSpecProps[PdtSpecProps.PdtStyle];
                    }

                    if(firstSpecProps[PdtSpecProps.Version]) {
                        $scope.form[PdtSpecProps.Version] = firstSpecProps[PdtSpecProps.Version];
                    }

                    if(firstSpecProps[PdtSpecProps.AreaRange]) {
                        $scope.form[PdtSpecProps.AreaRange] = firstSpecProps[PdtSpecProps.AreaRange];
                    }

                    if(firstSpecProps[PdtSpecProps.Thickness]) {
                        $scope.form[PdtSpecProps.Thickness] = firstSpecProps[PdtSpecProps.Thickness];
                    }

                    if(firstSpecProps[PdtSpecProps.Volume]) {
                        $scope.form[PdtSpecProps.Volume] = firstSpecProps[PdtSpecProps.Volume];
                    }

                    if(firstSpecProps[PdtSpecProps.Dpi]) {
                        $scope.form[PdtSpecProps.Dpi] = firstSpecProps[PdtSpecProps.Dpi];
                    }

                    if(firstSpecProps[PdtSpecProps.Bronzing]) {
                        $scope.form[PdtSpecProps.Bronzing] = firstSpecProps[PdtSpecProps.Bronzing];
                    }

                    var imageDimension = {};
                    var hasImageDimension = false;

                    if(firstSpecProps[PdtSpecProps.ImageLength]) {
                        imageDimension[PdtSpecProps.ImageLength] = firstSpecProps[PdtSpecProps.ImageLength];
                        hasImageDimension = true;
                    }

                    if(firstSpecProps[PdtSpecProps.ImageWidth]) {
                        imageDimension[PdtSpecProps.ImageWidth] = firstSpecProps[PdtSpecProps.ImageWidth];
                        hasImageDimension = true;
                    }

                    if(firstSpecProps[PdtSpecProps.ImageSizeRemark]) {
                        imageDimension[PdtSpecProps.ImageSizeRemark] = firstSpecProps[PdtSpecProps.ImageSizeRemark];
                        hasImageDimension = true;
                    }

                    if(hasImageDimension) {
                        $scope.form[ImageDimensionKey] = imageDimension;
                    }

                    if(firstSpecProps[PdtSpecProps.SleeveLength]) {
                        $scope.form[PdtSpecProps.SleeveLength] = firstSpecProps[PdtSpecProps.SleeveLength];
                    }

                    if(firstSpecProps[PdtSpecProps.ColorHex]) {
                        $scope.form[PdtSpecProps.ColorHex] = firstSpecProps[PdtSpecProps.ColorHex];
                    }
                }
            }

            // filter method
            var _filterSelect = function(propName, comparison, comparisonFunction) {

                selectResult = getSelectListAndDefault(filterMatrix, SpecPropsIndex[propName], $scope.form[propName], comparison, comparisonFunction);
                selectListMap[propName] = selectResult.selectList;
                $scope.form[propName] = selectResult.value;
                filterMatrix = filterSpecMatrix(filterMatrix, SpecPropsIndex[propName], $scope.form[propName], comparison, comparisonFunction);
            }

            // 第 1 層過濾： 材質
            _filterSelect(PdtSpecProps.MaterialType);
            // 第 2 層過濾： 樣式
            _filterSelect(PdtSpecProps.PdtStyle);
            // 第 3 層過濾： 袖長
            _filterSelect(PdtSpecProps.SleeveLength);
            // 第 4 層過濾： 尺寸
            _filterSelect(DimensionKey);
            // 第 5 層過濾： 顏色
            _filterSelect(PdtSpecProps.ColorHex, undefined, function(color1, color2) {
                return color1 && color2 && color1.hex === color2.hex && color1.subHex === color2.subHex 
                    && color1.isTranslucent === color2.isTranslucent;
            });
            // 第 6 層過濾： 版型
            _filterSelect(PdtSpecProps.Version);
            // 第 7 層過濾： 面積
            _filterSelect(PdtSpecProps.AreaRange);
            // 第 8 層過濾： 厚度
            _filterSelect(PdtSpecProps.Thickness);
            // 第 9 層過濾： 容量
            _filterSelect(PdtSpecProps.Volume);
            // 第 10 層過濾： 解析度
            _filterSelect(PdtSpecProps.Dpi);
            // 第 11 層過濾： 燙金
            _filterSelect(PdtSpecProps.Bronzing, 'name');
            // 第 12 層過濾： 印刷尺寸
            _filterSelect(ImageDimensionKey);
            
            // 將選好的欄位產生的選項列表做一些初始化
            initSelectListMap(selectListMap);

            // 過濾失敗防呆
            if(filterMatrix.length == 0) {
                $scope.form[DimensionKey] = $scope.specMatrix[0][SpecPropsIndex[DimensionKey]];
                $scope.form[PdtSpecProps.PdtStyle] = $scope.specMatrix[0][SpecPropsIndex[PdtSpecProps.PdtStyle]];
                $scope.form[PdtSpecProps.MaterialType] = $scope.specMatrix[0][SpecPropsIndex[PdtSpecProps.MaterialType]];
                $scope.form[PdtSpecProps.Version] = $scope.specMatrix[0][SpecPropsIndex[PdtSpecProps.Version]];
                $scope.form[PdtSpecProps.AreaRange] = $scope.specMatrix[0][SpecPropsIndex[PdtSpecProps.AreaRange]];
                $scope.form[PdtSpecProps.Thickness] = $scope.specMatrix[0][SpecPropsIndex[PdtSpecProps.Thickness]];
                $scope.form[PdtSpecProps.Volume] = $scope.specMatrix[0][SpecPropsIndex[PdtSpecProps.Volume]];
                $scope.form[PdtSpecProps.Dpi] = $scope.specMatrix[0][SpecPropsIndex[PdtSpecProps.Dpi]];
                $scope.form[PdtSpecProps.Bronzing] = $scope.specMatrix[0][SpecPropsIndex[PdtSpecProps.Bronzing]];
                $scope.form[ImageDimensionKey] = $scope.specMatrix[0][SpecPropsIndex[ImageDimensionKey]];
                $scope.form[PdtSpecProps.SleeveLength] = $scope.specMatrix[0][SpecPropsIndex[PdtSpecProps.SleeveLength]];
                $scope.form[PdtSpecProps.ColorHex] = $scope.specMatrix[0][SpecPropsIndex[PdtSpecProps.ColorHex]];

                filterSpec();
                return;
            } else if(filterMatrix.length >= 1) {
                var productid = filterMatrix[0][SpecPropsIndex[ProductidKey]];
                var specid = filterMatrix[0][SpecPropsIndex[SpecidKey]];
                $scope.spec = $scope.specMap[productid][specid];
                // 發現選到商品id跟目前不同，即是複合商品更換
                if(productid && productid != $scope.product.productid) {
                    var product = $scope.productMap[productid];
                    
                    if(product) {
                        changeComplexPdt && changeComplexPdt(product);
                        return;
                    }
                }

                $scope.form[DimensionKey] = filterMatrix[0][SpecPropsIndex[DimensionKey]];
                $scope.form[PdtSpecProps.PdtStyle] = filterMatrix[0][SpecPropsIndex[PdtSpecProps.PdtStyle]];
                $scope.form[PdtSpecProps.MaterialType] = filterMatrix[0][SpecPropsIndex[PdtSpecProps.MaterialType]];
                $scope.form[PdtSpecProps.Version] = filterMatrix[0][SpecPropsIndex[PdtSpecProps.Version]];
                $scope.form[PdtSpecProps.AreaRange] = filterMatrix[0][SpecPropsIndex[PdtSpecProps.AreaRange]];
                $scope.form[PdtSpecProps.Thickness] = filterMatrix[0][SpecPropsIndex[PdtSpecProps.Thickness]];
                $scope.form[PdtSpecProps.Volume] = filterMatrix[0][SpecPropsIndex[PdtSpecProps.Volume]];
                $scope.form[PdtSpecProps.Dpi] = filterMatrix[0][SpecPropsIndex[PdtSpecProps.Dpi]];
                $scope.form[PdtSpecProps.Bronzing] = filterMatrix[0][SpecPropsIndex[PdtSpecProps.Bronzing]];
                $scope.form[ImageDimensionKey] = filterMatrix[0][SpecPropsIndex[ImageDimensionKey]];
                $scope.form[PdtSpecProps.SleeveLength] = filterMatrix[0][SpecPropsIndex[PdtSpecProps.SleeveLength]];
                $scope.form[PdtSpecProps.ColorHex] = filterMatrix[0][SpecPropsIndex[PdtSpecProps.ColorHex]];

                checkSelect();
                return;
            }
        }

        // ------------------------------
        // 取得某個欄位的列表
        // ------------------------------
        var getSelectListAndDefault = function(matrix, index, value, comparison, comparisonFunction) {

            var selectList = [];
            var hasValue = false;
            var i, j, selectItem;

            if(!matrix || matrix.length === 0) {
                return {
                    selectList: selectList,
                    value: value
                };
            }

            // 將某個欄位所有可能值組合起來
            if(comparisonFunction) {
                for(i = 0; i < matrix.length; i++) {
                    var item = matrix[i][index];
                    var hasSame = false;

                    if(!hasValue && item && value && comparisonFunction(item, value)) {
                        hasValue = true;
                    }

                    for(j = 0; j < selectList.length; j++) {
                        selectItem = selectList[j];

                        if(item && selectItem && comparisonFunction(item, selectItem)) {
                            hasSame = true;
                            break;
                        }
                    }

                    if(!hasSame && item !== undefined) {
                        selectList.push(item);
                    }
                }
            } else if(comparison) {
                for(i = 0; i < matrix.length; i++) {
                    var item = matrix[i][index];
                    var hasSame = false;

                    if(!hasValue && item && value && item[comparison] === value[comparison]) {
                        hasValue = true;
                    }

                    for(j = 0; j < selectList.length; j++) {
                        selectItem = selectList[j];

                        if(item && selectItem && item[comparison] === selectItem[comparison]) {
                            hasSame = true;
                            break;
                        }
                    }

                    if(!hasSame && item !== undefined) {
                        selectList.push(item);
                    }
                }
            } else {
                for(i = 0; i < matrix.length; i++) {
                    var item = matrix[i][index];
                    var hasSame = false;

                    if(!hasValue && (item === value || JSON.stringify(item) === JSON.stringify(value))) {
                        hasValue = true;
                    }

                    for(j = 0; j < selectList.length; j++) {
                        selectItem = selectList[j];

                        if(item === selectItem || JSON.stringify(item) === JSON.stringify(selectItem)) {
                            hasSame = true;
                            break;
                        }
                    }

                    if(!hasSame && item !== undefined) {
                        selectList.push(item);
                    }
                }
            }


            for(i = 0; i < matrix.length; i++) {

                var item = matrix[i][index];
                var hasSame = false;

                // 將某個欄位所有可能值組合起來
                if(!comparison) {
                    if(!hasValue && (item === value || JSON.stringify(item) === JSON.stringify(value))) {
                        hasValue = true;
                    }

                    for(j = 0; j < selectList.length; j++) {
                        selectItem = selectList[j];

                        if(item === selectItem || JSON.stringify(item) === JSON.stringify(selectItem)) {
                            hasSame = true;
                            break;
                        }
                    }
                } else {
                    if(!hasValue && item && value && item[comparison] === value[comparison]) {
                        hasValue = true;
                    }

                    for(j = 0; j < selectList.length; j++) {
                        selectItem = selectList[j];

                        if(item && selectItem && item[comparison] === selectItem[comparison]) {
                            hasSame = true;
                            break;
                        }
                    }
                }                

                if(!hasSame && item !== undefined) {
                    selectList.push(item);
                }
            }

            if(!hasValue) {
                value = selectList[0];
            }

            return {
                selectList: selectList,
                value: value
            };
        }

        // ------------------------------
        // 過濾 SpecMatrix 中某個欄位
        // ------------------------------
        var filterSpecMatrix = function(matrix, index, value, comparison, comparisonFunction) {

            var filterMatrix = [];

            if(!matrix || matrix.length === 0) {
                return filterMatrix;
            }

            if(value === undefined) {
                return matrix;
            }

            var i, item;

            // 過濾某個欄位，將所有相同欄位的list組合起來
            if(comparisonFunction) {
                for(i = 0; i < matrix.length; i++) {

                    item = matrix[i][index];

                    if(item && value && comparisonFunction(item, value)) {
                        filterMatrix.push(matrix[i]);
                    }
                }
            } else if(comparison) {
                for(i = 0; i < matrix.length; i++) {

                    item = matrix[i][index];

                    if(item && value && item[comparison] === value[comparison]) {
                        filterMatrix.push(matrix[i]);
                    }
                }
            } else {
                for(i = 0; i < matrix.length; i++) {

                    item = matrix[i][index];

                    if(item === value || JSON.stringify(item) === JSON.stringify(value)) {
                        filterMatrix.push(matrix[i]);
                    }
                }
            }

            return filterMatrix;
        }

        // ------------------------------
        // 將選好的欄位產生的選項列表做一些初始化
        // ------------------------------
        var initSelectListMap = function(selectListMap) {
            
            // 排序須排序的規格選單
            sortSelectList(selectListMap);
            // 有些規格如果有undefined，要幫他補上無的選項
            formatHasUndefinedValueSpecList(selectListMap);

            $scope.selectListMap = selectListMap;
        }

        // ------------------------------
        // 排序須排序的規格選單
        // ------------------------------
        var sortSelectList = function(selectListMap) {

        }

        // ------------------------------
        // 有些規格如果有undefined，要幫他補上無的選項
        // ------------------------------
        var formatHasUndefinedValueSpecList = function(selectListMap) {

        }

        // ------------------------------
        // 取得列表中預設值
        // ------------------------------
        var getDefaultValueByList = function(list, value, comparison, defaultIndex) {

            var result = undefined;

            if(!Array.isArray(list) || list.length === 0) {
                return result;
            }

            if(defaultIndex < list.length) {
                result = list[defaultIndex];
            } else {
                result = list[0];
            }


            if(value === undefined) {
                return result;
            }

            var i, item;

            // 過濾某個欄位，將所有相同欄位的list組合起來
            if(!comparison) {
                for(i = 0; i < list.length; i++) {

                    item = list[i];

                    if(item === value || JSON.stringify(item) === JSON.stringify(value)) {
                        result = item;
                        break;
                    }
                }
            } else {
                for(i = 0; i < list.length; i++) {

                    item = list[i];

                    if(item && value && item[comparison] === value[comparison]) {
                        result = item;
                        break;
                    }
                }
            }

            return result;
        }

        // ------------------------------
        // 檢查選取值(非索引欄位)是否符合規格內容
        // ------------------------------
        var checkSelect = function() {

            var specProps = $scope.spec.specProps;
            var countList = $scope.spec.countList;

            var selectCount = $scope.form[CountKey];
            if(Array.isArray(countList) && countList.length > 0) {
                if(selectCount == undefined || selectCount < countList[0]) {
                    // 是否選取數量，沒選擇預設第一個
                    $scope.form[CountKey] = countList[0];
                } else if(countList.indexOf(selectCount) == -1) {

                    var priceRuleType = $scope.spec.priceRuleType;

                    switch(priceRuleType) {
                        case PriceRuleType.COUNT_RULE:
                            break;
                        case PriceRuleType.DEFAULT_RULE:
                        default:
                            var last = countList[countList.length - 1];
                            var max = last * CountMaxMultiple;
                            
                            if(selectCount > max || selectCount < last || selectCount % last !== 0) {
                                $scope.form[CountKey] = countList[0];    
                            }
                            break;
                    }
                }
            } else {
                if(selectCount == undefined) {
                    $scope.form[CountKey] = 1;
                }
            }

            var isOneSide = specProps[PdtSpecProps.IsOneSide];
            var isTwoSide = specProps[PdtSpecProps.IsTwoSide];

            // 先檢查是否選過單雙面
            if($scope.form[OneTwoSideKey]) {
                $scope.form[PdtSpecProps.IsOneSide] = false;
                $scope.form[PdtSpecProps.IsTwoSide] = false;
                $scope.form[$scope.form[OneTwoSideKey]] = true;
            }

            // 再檢查商品是否有單雙面，檢查他單雙面是否只有選一項
            if(isOneSide === true && isTwoSide === true) {
                if($scope.form[PdtSpecProps.IsOneSide] && $scope.form[PdtSpecProps.IsTwoSide]) {
                    $scope.form[PdtSpecProps.IsOneSide] = false;
                    $scope.form[PdtSpecProps.IsTwoSide] = true;
                } else if(!$scope.form[PdtSpecProps.IsOneSide] && !$scope.form[PdtSpecProps.IsTwoSide]) {
                    $scope.form[PdtSpecProps.IsOneSide] = false;
                    $scope.form[PdtSpecProps.IsTwoSide] = true;
                }
            } else if(isOneSide === true) {
                if(!$scope.form[PdtSpecProps.IsOneSide]) {
                    $scope.form[PdtSpecProps.IsOneSide] = true;
                }
                $scope.form[PdtSpecProps.IsTwoSide] = false;
            } else if(isTwoSide === true) {
                if(!$scope.form[PdtSpecProps.IsTwoSide]) {
                    $scope.form[PdtSpecProps.IsTwoSide] = true;
                }
                $scope.form[PdtSpecProps.IsOneSide] = false;
            } else {
                $scope.form[PdtSpecProps.IsOneSide] = false;
                $scope.form[PdtSpecProps.IsTwoSide] = false;
            }

            // 單雙面選項判斷值防呆
            if($scope.form[PdtSpecProps.IsOneSide]) {
                $scope.form[OneTwoSideKey] = PdtSpecProps.IsOneSide;
            } else if($scope.form[PdtSpecProps.IsTwoSide]) {
                $scope.form[OneTwoSideKey] = PdtSpecProps.IsTwoSide;
            } else {
                $scope.form[OneTwoSideKey] = undefined;
            }

            if(isPropSupport(PdtSpecProps.DesignRequirementList)) {
                var designRequirementList = specProps[PdtSpecProps.DesignRequirementList];
                var designRequirement = $scope.form[PdtSpecProps.DesignRequirement];
                $scope.form[PdtSpecProps.DesignRequirement] = getDefaultValueByList(designRequirementList, designRequirement);
            } else {
                $scope.form[PdtSpecProps.PrintingType] = undefined;
            }

            if(isPropSupport(PdtSpecProps.PrintingTypeList)) {
                var printingTypeList = specProps[PdtSpecProps.PrintingTypeList];
                var printingType = $scope.form[PdtSpecProps.PrintingType];
                $scope.form[PdtSpecProps.PrintingType] = getDefaultValueByList(printingTypeList, printingType);
            } else {
                $scope.form[PdtSpecProps.PrintingType] = undefined;
            }
            
            // 衣服尺寸
            if(isPropSupport(PdtSpecProps.ClothingSizeList)) {
                $scope.form[PdtSpecProps.ClothingSizeList] = getClothingSizeListForm($scope.spec.specProps);
            } else {
                $scope.form[PdtSpecProps.ClothingSizeList] = undefined;
            }

            // 印刷範圍
            if(isPropSupport(PdtSpecProps.PrintingAreaList)) {
                $scope.form[PdtSpecProps.PrintingAreaList] = getPrintingAreaListForm($scope.spec.specProps);
            } else {
                $scope.form[PdtSpecProps.PrintingAreaList] = undefined;
            }

            // 印刷顏色數量
            if(isPropSupport(PdtSpecProps.PrintingColorCountList)) {
                var printingColorCountList = specProps[PdtSpecProps.PrintingColorCountList];
                var printingColorCount = $scope.form[PdtSpecProps.PrintingColorCount];
                $scope.form[PdtSpecProps.PrintingColorCount] = getDefaultValueByList(printingColorCountList, printingColorCount, 'name');
            } else {
                $scope.form[PdtSpecProps.PrintingColorCount] = undefined;
            }

            if(!isPropSupport(PdtSpecProps.IsEmergency)) {
                $scope.form[PdtSpecProps.IsEmergency] = false;
            }

            if(isPropSupport(PdtSpecProps.PrintingPathCountList)) {
                $scope.form[PdtSpecProps.PrintingPathCount] = undefined;
            }

            // 滾邊色
            if(isPropSupport(PdtSpecProps.RollingColorHexList)) {
                var rollingColorHexList = specProps[PdtSpecProps.RollingColorHexList];
                var rollingColorHex = $scope.form[PdtSpecProps.RollingColorHex];
                $scope.form[PdtSpecProps.RollingColorHex] = getDefaultValueByList(rollingColorHexList, rollingColorHex, 'hex');
            } else {
                $scope.form[PdtSpecProps.RollingColorHex] = undefined;
            }

            // 加工
            var processList = $scope.form[ProcessKey];
            var specProcessList = $scope.spec[ProcessKey];
            var new_processList = [];

            // 將已選取的spec加入
            if(Array.isArray(processList) && processList.length > 0) {
                if(Array.isArray(specProcessList) && specProcessList.length > 0) {

                    for(var i = 0; i < processList.length; i++) {
                        for(var j = 0 ; j < specProcessList.length ; j++) {
                            if(processList[i].key == specProcessList[j].key) {
                                new_processList.push(processList[i]);
                                break;
                            }
                        }
                    }
                }
            }

            $scope.form[ProcessKey] = new_processList;

            var offerProcessList = $scope.form[OfferProcessKey];
            var specOfferProcessList = $scope.spec[OfferProcessKey];
            var new_offerProcessList = [];

            // 將已選取的spec加入
            if(Array.isArray(offerProcessList) && offerProcessList.length > 0) {
                if(Array.isArray(specOfferProcessList) && specOfferProcessList.length > 0) {

                    for(var i = 0; i < offerProcessList.length; i++) {
                        for(var j = 0 ; j < specOfferProcessList.length ; j++) {
                            if(offerProcessList[i].key == specOfferProcessList[j].key) {
                                new_offerProcessList.push(offerProcessList[i]);
                                break;
                            }
                        }
                    }
                }
            }

            $scope.form[OfferProcessKey] = new_offerProcessList;
            
            initOtherSelectList();
            initCountSelectType();
            refreshPrice();
        }

        // ------------------------------
        // 初始化選擇衣服尺寸的選項
        // ------------------------------
        var getClothingSizeListForm = function(specProps) {

            var clothingSizeList = $scope.form[PdtSpecProps.ClothingSizeList];
            var spec_clothingSizeList = specProps[PdtSpecProps.ClothingSizeList];
            var new_clothingSizeList = [];

            // 將已選取的spec加入
            if(Array.isArray(clothingSizeList) && clothingSizeList.length > 0) {
                if(Array.isArray(spec_clothingSizeList) && spec_clothingSizeList.length > 0) {
                    for(var i = 0; i < clothingSizeList.length; i++) {
                        var clothingSize = clothingSizeList[i];
                        for(var j = 0 ; j < spec_clothingSizeList.length ; j++) {
                            var spec_clothingSize = spec_clothingSizeList[j];

                            if(isClothingSizeEqual(clothingSize, spec_clothingSize)) {
                                spec_clothingSize.count = clothingSize.count;
                                new_clothingSizeList.push(spec_clothingSize);
                                break;
                            }
                        }
                    }
                }
            }

            return new_clothingSizeList;
        }

        // ------------------------------
        // 初始化印刷範圍選項
        // ------------------------------
        var getPrintingAreaListForm = function(specProps) {

            var printingAreaList = $scope.form[PdtSpecProps.PrintingAreaList];
            var spec_printingAreaList = specProps[PdtSpecProps.PrintingAreaList];
            var new_printingAreaList = [];

            // 將已選取的spec加入
            if(Array.isArray(printingAreaList) && printingAreaList.length > 0) {
                if(Array.isArray(spec_printingAreaList) && spec_printingAreaList.length > 0) {
                    for(var i = 0; i < printingAreaList.length; i++) {
                        var printingArea = printingAreaList[i];
                        for(var j = 0 ; j < spec_printingAreaList.length ; j++) {
                            var spec_printingArea = spec_printingAreaList[j];

                            if(printingArea.name == spec_printingArea.name) {
                                // spec_printingArea.length = printingArea.length;
                                spec_printingArea.width = printingArea.width;
                                spec_printingArea.height = printingArea.height;
                                new_printingAreaList.push(spec_printingArea);
                                break;
                            }
                        }
                    }
                }
            }

            return new_printingAreaList;
        }

        // ------------------------------
        // 取得網版印刷最小印刷數
        // ------------------------------
        var getPrintingMinCount = function(spec, form) {

            var minCount = 1;
            var printingType = form[PdtSpecProps.PrintingType];

            // 如果有網版印刷設定時
            if(isPropSupport(PdtSpecProps.PrintingTypeList) && printingType === ProductUtil.PdtPrintingType.SCREEN_PRINTING
                && isPropSupport(PdtSpecProps.PrintingMinCount) && spec.specProps[PdtSpecProps.PrintingMinCount] > 0
            ) {
                minCount = spec.specProps[PdtSpecProps.PrintingMinCount];
            }

            return minCount
        }

        // ------------------------------
        // 產生其他選項列表
        // ------------------------------
        var initOtherSelectList = function() {

            initCountList();
            initSideList();
        }

        // ------------------------------
        // 產生 數量 列表
        // ------------------------------
        var initCountList = function() {

            var list = [];
            var _minCount = getPrintingMinCount($scope.spec, $scope.form);
            var priceRuleType = $scope.spec.priceRuleType;

            if($scope.spec && Array.isArray($scope.spec.countList) && $scope.spec.countList.length > 0) {
                var _countList = $scope.spec.countList;
                var last = _countList[_countList.length - 1],
                    multiple = 1;
                
                switch(priceRuleType) {
                    case PriceRuleType.DEFAULT_RULE:
                        multiple = _countList[_countList.length - 1];
                        break;
                    case PriceRuleType.COUNT_RULE:
                        multiple = 1;
                        break;
                    default:
                        multiple = _countList[_countList.length - 1];
                        break;
                }

                var minCount = Math.max(_minCount, last);

                for(var i = 0; i < _countList.length; i++) {

                    if(_countList[i] < minCount) {
                        continue;
                    }

                    list.push(_countList[i]);
                }
                
                for(var j = 2; j <= CountMaxMultiple; j++) {

                    if(multiple * (j) < minCount) {
                        continue;
                    }

                    list.push(multiple * (j));
                }
            }

            $scope.selectListMap[CountKey] = list;

            if($scope.form[CountKey] < list[0]) {
                $scope.form[CountKey] = list[0];
            }
        }

        // ------------------------------
        // 產生 單雙面 列表
        // ------------------------------
        var initSideList = function() {

            var list = [];

            var isSupportIsOneSide = isPropSupport(PdtSpecProps.IsOneSide);
            var isSupportIsTwoSide = isPropSupport(PdtSpecProps.IsTwoSide);
            var IsOneSide = $scope.spec.specProps[PdtSpecProps.IsOneSide];
            var IsTwoSide = $scope.spec.specProps[PdtSpecProps.IsTwoSide];

            if(isSupportIsTwoSide && IsTwoSide) {
                list.push(PdtSpecProps.IsTwoSide);
            }

            if(isSupportIsOneSide && IsOneSide) {
                list.push(PdtSpecProps.IsOneSide);
            }

            $scope.selectListMap[OneTwoSideKey] = list;
        }

        // ------------------------------
        // 判斷選擇數量的顯示模式
        // ------------------------------
        var initCountSelectType = function() {

            var priceRuleType = $scope.spec.priceRuleType;
            var clothingSizeList = $scope.spec.specProps[PdtSpecProps.ClothingSizeList];
            var countSelectType;

            if(Array.isArray(clothingSizeList) && clothingSizeList.length > 0) {
                countSelectType = CountLayoutType.ClothinghSize; // 尺碼與件數
            } else {
                switch(priceRuleType) {
                    case PriceRuleType.DEFAULT_RULE:
                        countSelectType = CountLayoutType.Options; // 選單
                        break;
                    case PriceRuleType.COUNT_RULE:
                        countSelectType = CountLayoutType.Custom; // 輸入框
                        break;
                    default:
                        countSelectType = CountLayoutType.Options; // 選單
                        break;
                }
            }

            $scope.form.countSelectType = countSelectType; 
        }

        // ------------------------------
        // 計算價錢
        // ------------------------------
        var refreshPrice = function() {

            var orderSpec = convertFormToOrderItemSpec($scope.spec, $scope.form, $scope.product),
                priceTable = $scope.product.priceTable;

            refreshOtherDelivery(orderSpec);

            $scope.isSpecError = false;

            if(!priceTable) {
                $scope.price = -1;
                $scope.isSpecError = true;
                return;
            }

            var _price = getPrice($scope, orderSpec, priceTable);

            _price = Math.round(_price);

            if(_price < 0) {
                $scope.price = -1;
                $scope.isSpecError = true;
                return;
            }

            if(ProcessPriceService.getIsLoaded()) {
                refreshPriceWithProcess(orderSpec, _price);
            } else {
                ProcessPriceService.loadInfo().then(function(result) {
                    refreshPriceWithProcess(orderSpec, _price);
                });
            }
        }

        // ------------------------------
        // 計算價錢（加工）
        // ------------------------------
        var refreshPriceWithProcess = function(orderSpec, _price) {

            var processPrice = ProcessPriceService.getProductProcessPriceCost($scope.product, orderSpec);

            $scope.processPrice = processPrice.totalPrice;
            $scope.processPriceCost = processPrice.processPriceCost;

            _price = _price + $scope.processPrice;

            refreshSpecAdditionalPrice(orderSpec, _price);
        }

        // ------------------------------
        // 計算價錢（規格額外價錢）
        // ------------------------------
        var refreshSpecAdditionalPrice = function(orderSpec, _price) {

            $scope.specAdditionalPrice = getSpecAdditionalPrice(orderSpec);
            $scope.price = _price + $scope.specAdditionalPrice;

            refreshAccessoryTotalPrice();
        }

        // ------------------------------
        // 計算價錢（規格額外價錢）
        // ------------------------------
        var getSpecAdditionalPrice = function(orderSpec) {

            var result = 0;
            var _price = 0;

            var count = orderSpec[CountKey];
            var specProps = orderSpec.specProps;

            // 燙金
            var bronzing = specProps[PdtSpecProps.Bronzing];

            if(bronzing) {
                var _price = 0;
                var bronzingBasicPrice = bronzing.basicPrice;
                var bronzingMiniUnitPrice = bronzing.miniUnitPrice;
                var bronzingPlatemakingPrice = bronzing.platemakingPrice;

                // 個數乘以單價
                _price = count * bronzingMiniUnitPrice;
                // 若小於基本價就算基本價
                if (_price < bronzingBasicPrice)
                {
                  _price = bronzingBasicPrice;
                }
                // 加上版費
                _price += bronzingPlatemakingPrice;
                result += _price;
            }

            // 衣服尺寸價格
            var clothingSizeList = specProps[PdtSpecProps.ClothingSizeList]

            if(Array.isArray(clothingSizeList) && clothingSizeList.length > 0) {
                var _price;
                for(var i = 0; i < clothingSizeList.length; i++) {
                    var clothingSize = clothingSizeList[i];

                    if(clothingSize.count > 0 && clothingSize.extraUnitPrice > 0) {
                        _price = clothingSize.count * clothingSize.extraUnitPrice;
                        result += _price;
                    }
                }
            }

            // 印幾處的價格
            var printingPathCount = specProps[PdtSpecProps.PrintingPathCount];

            if(printingPathCount && printingPathCount.extraUnitPrice > 0) {
                _price = count * printingPathCount.extraUnitPrice;
                result += _price;
            }

            return result;
        }

        // ------------------------------
        // 計算價錢（配件）
        // ------------------------------
        var refreshAccessoryTotalPrice = function() {

            var accessoryPrice = 0;

            if($scope.accessoryList.length > 0) {
                for(var p = 0; p < $scope.accessoryList.length; p++) {
                    var accessory = $scope.accessoryList[p];

                    if(accessory.isAccessorySelected) {
                        accessoryPrice += accessory.form.price;
                    }
                }
            }

            $scope.accessoryPrice = accessoryPrice;
            $scope.price += accessoryPrice;
        }

        // ------------------------------
        // 將前端的 form 轉換成 後端 OrderItemSpec 資料
        // ------------------------------
        var convertFormToOrderItemSpec = function(spec, form, product) {
            
            var CV_ITEM = { form: form }; // 多這層只是讓下面 form 在編輯器會變色，比較好看code...

            var orderSpec = {
                // 基本規格資料
                specid: spec.specid,
                erpProductId: spec.erpProductId,
                printingUnit: spec.printingUnit,
                platemaking: spec.platemaking,
                deliveryDate: spec.deliveryTime * spec.deliveryDateUnit.time,
                deliveryDateUnit: spec.deliveryDateUnit,
                count: getOrderItemCount(spec, CV_ITEM.form),
                process: Array.isArray(CV_ITEM.form[ProcessKey]) && CV_ITEM.form[ProcessKey].length > 0 ? CV_ITEM.form[ProcessKey] : undefined,
                offerProcess: Array.isArray(CV_ITEM.form[OfferProcessKey]) && CV_ITEM.form[OfferProcessKey].length > 0 ? CV_ITEM.form[OfferProcessKey] : undefined,
                priceRuleType: spec.priceRuleType, // 價格計算類型
                productDelivery: spec.productDelivery,
            };

            var _specProps = spec.specProps;

            var orderItemSpecProps = {
                [PdtSpecProps.Length]: _specProps[PdtSpecProps.Length],
                [PdtSpecProps.Width]: _specProps[PdtSpecProps.Width],
                [PdtSpecProps.Height]: _specProps[PdtSpecProps.Height],
                [PdtSpecProps.BleedLength]: _specProps[PdtSpecProps.BleedLength],
                [PdtSpecProps.BleedWidth]: _specProps[PdtSpecProps.BleedWidth],
                [PdtSpecProps.BleedHeight]: _specProps[PdtSpecProps.BleedHeight],
                [PdtSpecProps.SizeRemark]: _specProps[PdtSpecProps.SizeRemark],
                [PdtSpecProps.SizeUnit]: _specProps[PdtSpecProps.SizeUnit],
                [PdtSpecProps.IsOneSide]: _specProps[PdtSpecProps.IsOneSide] ? CV_ITEM.form[PdtSpecProps.IsOneSide] : false,
                [PdtSpecProps.IsTwoSide]: _specProps[PdtSpecProps.IsTwoSide] ? CV_ITEM.form[PdtSpecProps.IsTwoSide] : false,
                [PdtSpecProps.PdtStyle]: _specProps[PdtSpecProps.PdtStyle],
                [PdtSpecProps.MaterialType]: _specProps[PdtSpecProps.MaterialType],
                [PdtSpecProps.Version]: _specProps[PdtSpecProps.Version],
                [PdtSpecProps.Thickness]: _specProps[PdtSpecProps.Thickness],
                [PdtSpecProps.ThicknessUnit]: _specProps[PdtSpecProps.ThicknessUnit],
                [PdtSpecProps.AreaRange]: _specProps[PdtSpecProps.AreaRange],
                [PdtSpecProps.Modulus]: _specProps[PdtSpecProps.Modulus],
                [PdtSpecProps.Volume]: _specProps[PdtSpecProps.Volume],
                [PdtSpecProps.Bronzing]: CV_ITEM.form[PdtSpecProps.Bronzing],
                [PdtSpecProps.Dpi]: _specProps[PdtSpecProps.Dpi],
                [PdtSpecProps.ImageLength]: _specProps[PdtSpecProps.ImageLength],
                [PdtSpecProps.ImageWidth]: _specProps[PdtSpecProps.ImageWidth],
                [PdtSpecProps.ImageBleedLength]: _specProps[PdtSpecProps.ImageBleedLength],
                [PdtSpecProps.ImageBleedWidth]: _specProps[PdtSpecProps.ImageBleedWidth],
                [PdtSpecProps.ImageSizeRemark]: _specProps[PdtSpecProps.ImageSizeRemark],
                [PdtSpecProps.ImageSizeUnit]: _specProps[PdtSpecProps.ImageSizeUnit],
                [PdtSpecProps.SleeveLength]: _specProps[PdtSpecProps.SleeveLength],
                [PdtSpecProps.ColorHex]: CV_ITEM.form[PdtSpecProps.ColorHex],
                [PdtSpecProps.PrintingType]: CV_ITEM.form[PdtSpecProps.PrintingType],
                [PdtSpecProps.IsEmergency]: CV_ITEM.form[PdtSpecProps.IsEmergency],
                [PdtSpecProps.PrintingPathCount]: CV_ITEM.form[PdtSpecProps.PrintingPathCount],
                [PdtSpecProps.RollingColorHex]: CV_ITEM.form[PdtSpecProps.RollingColorHex],
                // 下面補
                [PdtSpecProps.DesignRequirement]: undefined,
                [PdtSpecProps.PrintingAreaList]: undefined,
                [PdtSpecProps.PrintingColorCount]: undefined,
                [PdtSpecProps.ClothingSizeList]: undefined,
            };

            if(!isPropSupport(PdtSpecProps.PrintingTypeList)) {
                // 沒有支援設定印刷方法，資料可補上設計需求
                orderItemSpecProps[PdtSpecProps.DesignRequirement] = CV_ITEM.form[PdtSpecProps.DesignRequirement];
            } else if(CV_ITEM.form[PdtSpecProps.PrintingType] === ProductUtil.PdtPrintingType.SCREEN_PRINTING) {
                // 如果是網版印刷，資料可補上設計需求、印刷範圍、印刷顏色數量
                orderItemSpecProps[PdtSpecProps.DesignRequirement] = CV_ITEM.form[PdtSpecProps.DesignRequirement];
                orderItemSpecProps[PdtSpecProps.PrintingAreaList] = Array.isArray(CV_ITEM.form[PdtSpecProps.PrintingAreaList]) && CV_ITEM.form[PdtSpecProps.PrintingAreaList].length > 0 ? CV_ITEM.form[PdtSpecProps.PrintingAreaList] : undefined;
                orderItemSpecProps[PdtSpecProps.PrintingColorCount] = CV_ITEM.form[PdtSpecProps.PrintingColorCount]
            }
            
            // 衣服尺寸
            orderItemSpecProps[PdtSpecProps.ClothingSizeList] = Array.isArray(CV_ITEM.form[PdtSpecProps.ClothingSizeList]) && CV_ITEM.form[PdtSpecProps.ClothingSizeList].length > 0 ? CV_ITEM.form[PdtSpecProps.ClothingSizeList] : undefined;

            // 商品沒支援那規格，就移除該欄位
            if(product && Array.isArray(product.orderItemSupportProps) && product.orderItemSupportProps.length) {
                orderSpec.specProps = {};

                for(var i = 0; i < product.orderItemSupportProps.length; i++) {
                    var prop = product.orderItemSupportProps[i];
                    orderSpec.specProps[prop] = orderItemSpecProps[prop];
                }
            } else {
                orderSpec.specProps = orderItemSpecProps;
            }
          
            return orderSpec;
        }

        // ------------------------------
        // 依照數量顯示樣式取得數量
        // ------------------------------
        var getOrderItemCount = function(spec, form) {

            var count = 0;
            
            $scope.isClothinghSizeCountError = false;

            switch(form.countSelectType) {
                case CountLayoutType.Options: // 選單
                case CountLayoutType.Custom: // 輸入框
                    count = form[CountKey];
                    break;
                case CountLayoutType.ClothinghSize: // 尺碼與件數
                    var clothingSizeList = form[PdtSpecProps.ClothingSizeList];

                    for(var i = 0; i < clothingSizeList.length; i++) {
                        var clothingSize = clothingSizeList[i];
                        if(!isNaN(clothingSize.count) && clothingSize.count > 0) {
                            count += clothingSize.count;
                        }
                    }

                    if(count === 0) {
                        $scope.isClothinghSizeCountError = true;
                    }

                    break;
                default:
                    count = form[CountKey];
                    break;
            }

            $scope.isLowerPrintingMinCountError = false;

            var minCount = getPrintingMinCount(spec, form);

            if(minCount > count && count > 0) {
                $scope.isLowerPrintingMinCountError = true;
            }

            return count;
        }

        // ------------------------------
        // 將後端 OrderItemSpec 轉換成 前端的 form 資料
        // ------------------------------
        var convertOrderItemSpecToForm = function(spec) {

            var form = {};

            if(!spec) {
                return form;
            }

            var specid = spec.specid;
            var count = spec.count;
            var processList = spec.process || [];
            var offerProcess = spec.offerProcess || [];

            if(specid) {
                form[SpecidKey] = specid;
            }

            if(count) {
                form[CountKey] = count;
            }
            
            if(processList) {
                form[ProcessKey] = processList;
            }

            if(offerProcess) {
                form[OfferProcessKey] = offerProcess;
            }

            var specProps = spec.specProps || {};
            var length = specProps[PdtSpecProps.Length];
            var width = specProps[PdtSpecProps.Width];
            var height = specProps[PdtSpecProps.Height];
            var sizeRemark = specProps[PdtSpecProps.SizeRemark];
            var dimension = {};
            var hasDimension = false;

            if(length) {
                dimension[PdtSpecProps.Length] = length;
                hasDimension = true;
            }

            if(width) {
                dimension[PdtSpecProps.Width] = width;
                hasDimension = true;
            }

            if(height) {
                dimension[PdtSpecProps.Height] = height;
                hasDimension = true;
            }

            if(sizeRemark) {
                dimension[PdtSpecProps.SizeRemark] = sizeRemark;
                hasDimension = true;
            }

            if(hasDimension) {
                form[DimensionKey] = dimension;
            }

            var imageLength = specProps[PdtSpecProps.ImageLength];
            var imageWidth = specProps[PdtSpecProps.ImageWidth];
            var imageSizeRemark = specProps[PdtSpecProps.ImageSizeRemark];
            var imageDimension = {};
            var hasImageDimension = false;

            if(imageLength) {
                imageDimension[PdtSpecProps.ImageLength] = imageLength;
                hasImageDimension = true;
            }

            if(imageWidth) {
                imageDimension[PdtSpecProps.ImageWidth] = imageWidth;
                hasImageDimension = true;
            }

            if(imageSizeRemark) {
                imageDimension[PdtSpecProps.ImageSizeRemark] = imageSizeRemark;
                hasImageDimension = true;
            }

            if(hasImageDimension) {
                form[ImageDimensionKey] = imageDimension;
            }

            for(var key in specProps) {
                switch(key) {
                    case PdtSpecProps.Length:
                    case PdtSpecProps.Width:
                    case PdtSpecProps.Height:
                    case PdtSpecProps.SizeRemark:
                    case PdtSpecProps.ImageLength:
                    case PdtSpecProps.ImageWidth:
                    case PdtSpecProps.ImageSizeRemark:
                        break;
                    default:
                        form[key] = specProps[key];
                        break;
                }
            }

            return form;
        }

        // ------------------------------
        // 取得該規格的價錢
        // ------------------------------
        var getPrice = function(_scope_, orderSpec, priceTable) {

            switch(orderSpec.priceRuleType) {
                case PriceRuleType.DEFAULT_RULE:
                    return getPriceByDefaultRule(_scope_, orderSpec, priceTable.rule);
                case PriceRuleType.COUNT_RULE:
                    return getPriceByCountRule(_scope_, orderSpec, priceTable.countRule);
                default:
                    return -1;
            }
        }

        // ------------------------------
        // 取得該規格的價錢 (預設規則)
        // ------------------------------
        var getPriceByDefaultRule = function(_scope_, orderSpec, rule) {

            if(!orderSpec || !rule) {
                return -1;
            }

            if(!_scope_) {
                _scope_ = $scope;
            }

            var specid = orderSpec[SpecidKey];
            var count = orderSpec[CountKey];
            var specProps = orderSpec.specProps;
            var isOneSide = specProps[PdtSpecProps.IsOneSide];
            var isTwoSide = specProps[PdtSpecProps.IsTwoSide];

            var _key = specid;

            if(isOneSide) {
                _key += "V";
            } else if(isTwoSide) {
                _key += "W";
            }

            var key = _key + count;
            var price = rule[key];

            if(!window.isNaN(price) && price > 0) {
                return price;
            }

            // 沒有找到代表有可能是更多數量，先檢查是否為最大數的倍數
            var countList = _scope_.spec.countList;
            var last = countList[countList.length - 1];
            
            key = _key + last;

            var lastPrice = rule[key];

            if(window.isNaN(lastPrice) || lastPrice <= 0) {
                return -1;
            }

            if(last > 0 && count > last && count % last === 0) {
                price = lastPrice * (Math.floor(count / last));
                return price;
            }

            return -1;
        }

        // ------------------------------
        // 取得該規格的價錢 (數量規則)
        // ------------------------------
        var getPriceByCountRule = function(_scope_, orderSpec, countRule) {

            if(!countRule) {
                return -1;
            }

            if(!_scope_) {
                _scope_ = $scope;
            }

            var specid = orderSpec[SpecidKey];
            var count = orderSpec[CountKey];
            var specProps = orderSpec.specProps;
            var isOneSide = specProps[PdtSpecProps.IsOneSide];
            var isTwoSide = specProps[PdtSpecProps.IsTwoSide];
            var minCount = _scope_.selectListMap[CountKey][0];

            if(count < minCount) {
                return -1;
            }

            var key = specid;

            if(isOneSide) {
                key += "V";
            } else if(isTwoSide) {
                key += "W";
            }

            var countObj = countRule[key];

            if(!countObj || !countObj.floorCountUnitPriceMap) {
                return -1;
            }

            var unitPrice = 0;
            var basicPrice = countObj.basicPrice || 0;

            for(var i = count; i > 0; i--) {
                if(countObj.floorCountUnitPriceMap[i]) {
                    unitPrice = countObj.floorCountUnitPriceMap[i];
                    break;
                }
            }

            if(unitPrice > 0) {
                var result = count * unitPrice;

                if(result < basicPrice) {
                    result = basicPrice;
                }

                return result;
            } else {
                return -1;   
            }
        }

        // ------------------------------
        // [SCOPE] 尺寸單位
        // ------------------------------
        var getSizeUnit = function(key) {

            if(!$scope.spec || !$scope.spec.specProps) {
                return '';
            }

            var specProps = $scope.spec.specProps;
            var unit = specProps[key];

            return ProductUtil.getSizeUnitHtml(unit);
        }

        // ------------------------------
        // [SCOPE] 尺寸單位
        // ------------------------------
        var getSizeUnitByInt = function(unit) {

            return ProductUtil.getSizeUnitHtml(unit);
        }

        // ------------------------------
        // [SCOPE] 取得開版日
        // ------------------------------
        var getPlatemakingString = function(platemaking) {

            if(!platemaking) {
                return;
            }

            var result = '每週';
            var platemakingMap = {1: '一', 2: '二', 3: '三', 4: '四', 5: '五', 6: '六', 7: '日'}
            var trueCount = 0;

            for(var i = 1; i <= 7; i++) {

                if(platemaking[i]) {

                    if(trueCount > 0) {
                        result += '、';
                    }

                    result += platemakingMap[i];
                    trueCount++;
                }
            }

            if(trueCount == 7) {
                result = '每日';
            }

            return result + '開版';
        }

        // ------------------------------
        // [SCOPE] 取得出血尺寸
        // ------------------------------
        var getBleedSize = function() {

            var bleedSize = '';

            if(!$scope.spec || !$scope.spec.specProps) {
                return bleedSize;
            }

            var specProps = $scope.spec.specProps;

            var bleedLength = isPropSupport(PdtSpecProps.BleedLength) && specProps[PdtSpecProps.BleedLength];
            var bleedWidth = isPropSupport(PdtSpecProps.BleedWidth) && specProps[PdtSpecProps.BleedWidth];
            var bleedHeight = isPropSupport(PdtSpecProps.BleedHeight) && specProps[PdtSpecProps.BleedHeight];
            var sizeUnit = specProps[PdtSpecProps.SizeUnit];

            if(!bleedLength && !bleedWidth && !bleedHeight) {
                return bleedSize;
            }

            if(bleedLength > 0) {
                bleedSize += bleedLength;
            }

            if(bleedWidth > 0) {
                if(bleedSize) {
                    bleedSize += ' x ';
                }

                bleedSize += bleedWidth;
            }

            if(bleedHeight > 0) {
                if(bleedSize) {
                    bleedSize += ' x ';
                }

                bleedSize += bleedHeight;
            }

            if(!bleedSize) {
                return bleedSize;
            }

            bleedSize = '出血尺寸：' + bleedSize + ProductUtil.getSizeUnitText(sizeUnit, true);

            return bleedSize;
        }

        // ------------------------------
        // [SCOPE] 當選項值更改時
        // ------------------------------
        var onFormValueChange = function(option, active, key) {

            if(!key && !active) {
                return;
            }

            $scope.form[key] = option;


            var filterIndex = SpecPropsIndex[key];

            // 是索引值再重新過濾，不是則更新金額即可
            if(filterIndex >= 0) {
                filterSpec();
            } else {
                refreshPrice();
            }
        }
        
        // ------------------------------
        // [SCOPE] 是否選到該尺寸
        // ------------------------------
        var isDimensionActive = function(option, dimension) {

            var active = option == dimension || 
                (option[PdtSpecProps.Length] == dimension[PdtSpecProps.Length] && option[PdtSpecProps.Width] == dimension[PdtSpecProps.Width]
                    && option[PdtSpecProps.Height] == dimension[PdtSpecProps.Height] && option[PdtSpecProps.SizeRemark] == dimension[PdtSpecProps.SizeRemark]
            );

            return active;
        }

        // ------------------------------
        // [SCOPE] 取得尺寸文字
        // ------------------------------
        var getDimensionString = function(option) {

            var text = '';
            var length = option[PdtSpecProps.Length];
            var width = option[PdtSpecProps.Width];
            var height = option[PdtSpecProps.Height];
            var sizeRemark = option[PdtSpecProps.SizeRemark];

            if(length) {
                text += length;
            }

            if(width) {

                if(text) {
                    text += ' x ';
                }

                text += width;
            }

            if(height) {

                if(text) {
                    text += ' x ';
                }

                text += height;
            }

            var specProps = $scope.spec.specProps;
            var sizeUnit = specProps[PdtSpecProps.SizeUnit];
            var sizeUnitText = ProductUtil.getSizeUnitText(sizeUnit, true);
            
            if(sizeUnitText) {
                text = text + ' ' + sizeUnitText + ' ';
            }

            if(sizeRemark) {
                text = sizeRemark + '(' + text + ')';
            }

            return text;
        }

        // ------------------------------
        // [SCOPE] 取得解析度文字
        // ------------------------------
        var getDpiString = function(option) {

            return option + 'dpi';
        }

        // ------------------------------
        // [SCOPE] 是否選到該面積
        // ------------------------------
        var isAreaRangeActive = function(option, areaRange) {

            var active = option == areaRange || (option.rangeStart == areaRange.rangeStart && option.rangeEnd == areaRange.rangeEnd);

            return active;
        }
        
        // ------------------------------
        // [SCOPE] 取得面積文字
        // ------------------------------
        var getAreaRangeHtmlString = function(option) {

            var html = '<span>';

            html += option.rangeStart;
            html += ' ~ ';
            html += option.rangeEnd;
            
            var sizeUnitHtml = getSizeUnit(PdtSpecProps.SizeUnit);
            
            if(sizeUnitHtml) {
                html += '<span class="unit">';
                html += sizeUnitHtml;
                html += '</span>';
            }

            html += '</span>';

            return html;
        }

        // ------------------------------
        // [SCOPE] 取得厚度文字
        // ------------------------------
        var getThicknessString = function(option) {

            var text = option;

            var specProps = $scope.spec.specProps;
            var sizeUnit = specProps[PdtSpecProps.ThicknessUnit];
            var sizeUnitText = ProductUtil.getSizeUnitText(sizeUnit, true);
            
            if(sizeUnitText) {
                text = text + ' ' + sizeUnitText + ' ';
            }

            return text;
        }

        // ------------------------------
        // [SCOPE] 取得容量文字
        // ------------------------------
        var getVolumeString = function(option) {

            var text = option;

            var specProps = $scope.spec.specProps;
            var sizeUnit = specProps[PdtSpecProps.SizeUnit];
            var sizeUnitText = ProductUtil.getSizeUnitText(sizeUnit, true);
            
            if(sizeUnitText) {
                text = text + ' ' + sizeUnitText + ' ';
            }

            return text;
        }

        // ------------------------------
        // [SCOPE] 當自定義尺寸更動時
        // ------------------------------
        var onFreeSizeChange = function() {

            filterSpec();
        }

        // ------------------------------
        // [SCOPE] 是否選到該燙金
        // ------------------------------
        var isBronzingActive = function(option, bronzing) {

            var active = option == bronzing || (option.name == bronzing.name);

            return active;
        }

        // ------------------------------
        // [SCOPE] 取得燙金文字
        // ------------------------------
        var getBronzingString = function(option) {

            var text = option.name;

            return text;
        }

        // ------------------------------
        // [SCOPE] 取得單雙面文字
        // ------------------------------
        var getSideString = function(option) {

            var text = '';

            switch(option) {
                case PdtSpecProps.IsTwoSide:
                    text = '雙面';
                    break;
                case PdtSpecProps.IsOneSide:
                    text = '單面';
                    break;
                default:
                    break;
            }

            return text;
        }

        // ------------------------------
        // [SCOPE] 單雙面更動時
        // ------------------------------
        var onSideChange = function(option) {

            $scope.form[PdtSpecProps.IsTwoSide] = false;
            $scope.form[PdtSpecProps.IsOneSide] = false;
            $scope.form[option] = true;
            $scope.form[OneTwoSideKey] = option;

            refreshPrice();
        }
        
        // ------------------------------
        // [SCOPE] 取得數量文字
        // ------------------------------
        var getCountString = function(option) {

            var text = option + $scope.spec.printingUnit;

            return text;
        }

        // ------------------------------
        // [SCOPE] 數字資料更動時
        // ------------------------------
        var onNumberValueChange = function(key, min, max) {

            if(isNaN(min) || min <= 0) {
                // min = 1;
            } else {
                if(isNaN($scope.form[key]) || $scope.form[key] < min) {
                    $scope.form[key] = min;
                }                
            }


            if(!isNaN(max) && $scope.form[key] > max) {
                $scope.form[key] = max;
            }

            refreshPrice();
        }

        // ------------------------------
        // [SCOPE] 數量加1
        // ------------------------------
        var increaseCount = function() {

            $scope.form[CountKey]++;

            refreshPrice();
        }

        // ------------------------------
        // [SCOPE] 數量減1
        // ------------------------------
        var decreaseCount = function(min) {

            if(isNaN(min) || min <= 0) {
                min = 1;
            }

            if($scope.form[CountKey] <= min) {
                return;
            }

            $scope.form[CountKey]--;

            refreshPrice();
        }        

        // ------------------------------
        // [SCOPE] 是否選到該顏色
        // ------------------------------
        var isColorActive = function(option, color) {

            var active = option == color || (option.hex == color.hex && option.subHex == color.subHex && option.isTranslucent === color.isTranslucent);

            return active;
        }
        
        // ------------------------------
        // [SCOPE] 取得顏色文字
        // ------------------------------
        var getColorHtmlString = function(option) {

            var styleText;

            if(option.subHex) {
                styleText = 'background: linear-gradient(-45deg, ' + option.subHex + ' 50%, ' + option.hex + ' 50%);';
            } else {
                styleText = 'background-color: ' + option.hex + ';';
            }
            
            var html = '<div class="color-option"><div class="color" style="' + styleText + '"></div>';
            var hexText = option.colorName ? option.colorName : $filter('hexToName')(option.hex);

            html += hexText;

            if(option.isTranslucent) {
                html += '<span class="red">＊</span>';
            }

            html += '</div>';

            return html;
        }

        // ------------------------------
        // [SCOPE] 取得顏色方塊
        // ------------------------------
        var getColorHtmlBlock = function(option) {

            var styleText;

            if(option.subHex) {
                styleText = 'background: linear-gradient(-45deg, ' + option.subHex + ' 50%, ' + option.hex + ' 50%);';
            } else {
                styleText = 'background-color: ' + option.hex + ';';
            }

            var html = '<div class="color" style="' + styleText + '">';

            if(option.isTranslucent) {
                html += '<div class="transparent-tip"></div>';
            }

            html += '</div>';

            return html;
        }

        // ------------------------------
        // [SCOPE] 取得手機版顏色方塊
        // ------------------------------
        var getMobileColorHtmlBlock = function(option) {

            var styleText;

            if(option.subHex) {
                styleText = 'background: linear-gradient(-45deg, ' + option.subHex + ' 50%, ' + option.hex + ' 50%);';
            } else {
                styleText = 'background-color: ' + option.hex + ';';
            }

            var html = '<div class="spec-color" style="' + styleText + '">';

            if(option.isTranslucent) {
                html += '<div class="transparent-tip"></div>';
            }

            html += '</div>';

            return html;
        }
        
        // ------------------------------
        // [SCOPE] 是否選到該加工
        // ------------------------------
        var isProcessActive = function(option, form_process) {

            if(!Array.isArray($scope.form[ProcessKey])){
                return false;
            }

            for(var i = 0 ; i < $scope.form[ProcessKey].length ; i++) {
                if($scope.form[ProcessKey][i].key == option.key) {
                    return true;
                }
            }

            return false;
        }

        // ------------------------------
        // [SCOPE] 取得加工文字
        // ------------------------------
        var getProcessString = function(option) {

            var text = option.key;

            return text;
        }

        // ------------------------------
        // [SCOPE] 當加工更改時
        // ------------------------------
        var onProcessChange = function(option, active, key) {

            toggleProcess(option);
            refreshPrice();
        }

        // ------------------------------
        // 選取／取消 加工項目
        // ------------------------------
        var toggleProcess = function(_process) {

            if(!Array.isArray($scope.form[ProcessKey])){
                $scope.form[ProcessKey] = [];
                $scope.form[ProcessKey].push(_process);
                return;
            }

            // 單選模式
            if($scope.spec.isProcessRadio) {
                for(var i = 0 ; i < $scope.form[ProcessKey].length ; i++) {
                    var pro = $scope.form[ProcessKey][i];

                    if(pro.key == _process.key) {
                        break;
                    }
                }

                $scope.form[ProcessKey].length = 0;
            } else {
                for(var i = 0 ; i < $scope.form[ProcessKey].length ; i++) {
                    var pro = $scope.form[ProcessKey][i];

                    if(pro.key == _process.key) {
                        $scope.form[ProcessKey].remove(i);
                        return;
                    }
                }
            }

            $scope.form[ProcessKey].push(_process);
        }

        // ------------------------------
        // [SCOPE] 是否選到該特殊加工
        // ------------------------------
        var isOfferProcessActive = function(option, form_process) {

            if(!Array.isArray($scope.form[OfferProcessKey])){
                return false;
            }

            for(var i = 0 ; i < $scope.form[OfferProcessKey].length ; i++) {
                if($scope.form[OfferProcessKey][i].key == option.key) {
                    return true;
                }
            }

            return false;
        }

        // ------------------------------
        // [SCOPE] 取得特殊加工文字
        // ------------------------------
        var getOfferProcessString = function(option) {

            var text = option.key;

            return text;
        }

        // ------------------------------
        // [SCOPE] 當特殊加工更改時
        // ------------------------------
        var onOfferProcessChange = function(option, active, key) {

            toggleOfferProcess(option);
            refreshPrice();
        }

        // ------------------------------
        // 選取／取消 特殊加工項目
        // ------------------------------
        var toggleOfferProcess = function(_offerProcess) {

            if(!Array.isArray($scope.form[OfferProcessKey])){
                $scope.form[OfferProcessKey] = [];
                $scope.form[OfferProcessKey].push(_offerProcess);
                return;
            }

            // 單選模式
            if($scope.spec.isOfferProcessRadio) {
                for(var i = 0 ; i < $scope.form[OfferProcessKey].length ; i++) {
                    var pro = $scope.form[OfferProcessKey][i];

                    if(pro.key == _offerProcess.key) {
                        break;
                    }
                }

                $scope.form[OfferProcessKey].length = 0;
            } else {
                for(var i = 0 ; i < $scope.form[OfferProcessKey].length ; i++) {
                    var pro = $scope.form[OfferProcessKey][i];

                    if(pro.key == _offerProcess.key) {
                        $scope.form[OfferProcessKey].remove(i);
                        return;
                    }
                }
            }

            $scope.form[OfferProcessKey].push(_offerProcess);
        }

        // ------------------------------
        // [SCOPE] 檢查是否有勾選加工項目
        // ------------------------------
        var checkSelectedProcess = function() {

            return $scope.form && $scope.form[ProcessKey] && $scope.form[ProcessKey].length > 0;
        }

        // ------------------------------
        // [SCOPE] 檢查是否有勾選特殊加工項目
        // ------------------------------
        var checkSelectedOfferProcess = function() {

            return $scope.form && $scope.form[OfferProcessKey] && $scope.form[OfferProcessKey].length > 0;
        }
        
        // ------------------------------
        // [SCOPE] 取得設計需求文字
        // ------------------------------
        var getDesignRequirementString = function(option) {

            return ProductUtil.getProductDesignRequirementTypeText(option);
        }
      
        // ------------------------------
        // [SCOPE] 取得顯示畫面面上的價格
        // ------------------------------
        var getViewPrice = function() {

            if(checkSelectedOfferProcess()) {
                return '等待專人報價';
            }

            if($scope.form[PdtSpecProps.PrintingType] !== undefined 
                && $scope.form[PdtSpecProps.PrintingType] === ProductUtil.PdtPrintingType.SCREEN_PRINTING
            ) {
                return '等待專人報價';
            }

            return $scope.price;
        }

        // ------------------------------
        // [SCOPE] 取得顯示畫面面上價格備註
        // ------------------------------
        var getViewPriceRemark = function() {

            var result = '';

            if(checkSelectedOfferProcess()) {
                result += '（商品含特殊加工';
            }

            if($scope.form[PdtSpecProps.PrintingType] !== undefined 
                && $scope.form[PdtSpecProps.PrintingType] === ProductUtil.PdtPrintingType.SCREEN_PRINTING
            ) {
                var printingTypeText = ProductUtil.getPdtPrintingTypeText(ProductUtil.PdtPrintingType.SCREEN_PRINTING);

                if(result) {
                    result += (' & ' + printingTypeText);
                } else {
                    result += ('（商品為' + printingTypeText);
                }
            }

            if(result) {
                result += "）";
            }

            return result;
        }

        // ------------------------------
        // [SCOPE] 關閉快速下單modal
        // ------------------------------
        var closeQuickOrder = function() {

            $ngModal.closeModal("quickly-order");
        }

        // ------------------------------
        // 檢查加工版費項目
        // ------------------------------
        var checkProcess = function() {

            if($scope.processPriceCost && $scope.processPriceCost[ProcessPriceService.PLATEMAKING_NAME]) {
                for(var i = 0; i < $scope.form[ProcessKey].length; i++) {
                    if($scope.form[ProcessKey][i].key == ProcessPriceService.PLATEMAKING_NAME) { // 避免新增兩個以上的版費
                        $scope.form[ProcessKey].splice(i, 1);
                    }
                }

                $scope.form[ProcessKey].push({
                    key: ProcessPriceService.PLATEMAKING_NAME,
                    value: '[' + ProcessPriceService.PLATEMAKING_NAME + ']'
                });
            }

            var hasBronzing = false;
            // 特殊加工遇到燙金燙銀要補上版費
            for(var i = 0; i < $scope.form[OfferProcessKey].length; i++) {
                if($scope.form[OfferProcessKey][i].key == '燙金' || $scope.form[OfferProcessKey][i].key == '燙銀') {
                    hasBronzing = true;
                } else if($scope.form[OfferProcessKey][i].key == ProcessPriceService.PLATEMAKING_NAME) { // 避免新增兩個以上的版費
                    $scope.form[OfferProcessKey].splice(i, 1);
                }
            }

            if(hasBronzing) {
                $scope.form[OfferProcessKey].push({
                    key: ProcessPriceService.PLATEMAKING_NAME,
                    value: '[' + ProcessPriceService.PLATEMAKING_NAME + ']'
                });
            }
        }

        // ------------------------------
        // 重新計算出貨日
        // ------------------------------
        var refreshOtherDelivery = function(orderSpec) {

            if(ProductDeliveryService.getIsLoaded()) {
                _refreshOtherDelivery(orderSpec);
            } else {
                ProductDeliveryService.loadInfo().then(function(result) {
                    _refreshOtherDelivery(orderSpec);
                });
            }
        }

        // ------------------------------
        // 重新計算出貨日
        // ------------------------------
        var _refreshOtherDelivery = function(orderSpec) {
            var processDelivery = ProductDeliveryService.getProcessDelivery($scope.product.pdtClass, $scope.form[ProcessKey]);
            var offer_processDelivery = ProductDeliveryService.getProcessDelivery($scope.product.pdtClass, $scope.form[OfferProcessKey]);
            var specDelivery = ProductDeliveryService.getSpecDelivery($scope.product.pdtClass, orderSpec);

            $scope.form.otherDeliveryTime = processDelivery + offer_processDelivery + specDelivery;
        }

        // ------------------------------
        // [SCOPE] 選擇配件
        // ------------------------------
        var toggleAccessorySelected = function(accessory) {

            accessory.isAccessorySelected = !accessory.isAccessorySelected;

            refreshPrice();
        }

        // ------------------------------
        // [SCOPE] 取得配件圖片
        // ------------------------------
        var getAccessoryImage = function(accessory, type) {

            if(!type) {
                type = 'small';
            }

            if(!Array.isArray(accessory.covers) || !accessory.covers[0]){
                return "about:blank";
            }

            return accessory.covers[0].replace('medium', type);
        }

        // ------------------------------
        // [SCOPE] 顯示配件圖片
        // ------------------------------
        var showAccessoryImage = function(accessory) {

            accessory.isShowImage = true;
        }

        // ------------------------------
        // 重新整理配件金額
        // ------------------------------
        var refreshAccessoryPrice = function(accessory) {

            var orderSpec = convertFormToOrderItemSpec(accessory.spec, accessory.form, accessory),
            priceTable = accessory.priceTable;

            if(!priceTable) {
                accessory.form.price = 0;
                return;
            }

            var price = getPrice(accessory, orderSpec, priceTable) || 0;

            price = Math.round(price);

            accessory.form.price = price;

            refreshPrice();
        }

        // ------------------------------
        // 初始化配件數量選項
        // ------------------------------
        var initAccessoryCountList = function(accessory) {

            var spec = accessory.spec;
            var printingUnit = spec.printingUnit;
            var list = [];

            if(spec && Array.isArray(spec.countList) && spec.countList.length > 0) {
                var _countList = spec.countList;
                var last = _countList[_countList.length - 1];

                for(var i = 0; i < _countList.length; i++) {
                    list.push({
                        count: _countList[i],
                        printingUnit: printingUnit,
                    });
                }

                for(var j = 2; j <= CountMaxMultiple; j++) {
                    list.push({
                        count: last * (j),
                        printingUnit: printingUnit,
                    });
                }

                accessory.form.customCount = list[0];
            }

            accessory.customCountList = list;
        }

        // ------------------------------
        // [SCOPE] 是否選到該配件
        // ------------------------------
        var isAccessorySpecActive = function(option, value) {

            return option && value && option.specid === value.specid;
        }

        // ------------------------------
        // [SCOPE] 顯示配件規格名稱，目前為顯示樣式
        // ------------------------------
        var getAccessorySpecString = function(option) {

            var text = '';

            if(option && option.specProps && option.specProps[PdtSpecProps.PdtStyle]) {
                text = option.specProps[PdtSpecProps.PdtStyle];
            }

            return text;
        }

        // ------------------------------
        // [SCOPE] 選擇配件規格
        // ------------------------------
        var onAccessorySpecChange = function(option, active, key) {

            var accessory;

            for(var i = 0; i < $scope.accessoryList.length; i++) {
                accessory = $scope.accessoryList[i];
                if(accessory.productid === key) {
                    break;
                }
                accessory = undefined;
            }

            if(!accessory) {
                return;
            }

            var spec = option;

            accessory.spec = spec;

            if(spec.countList.indexOf(accessory.form.count) === -1) {
                accessory.form.count = spec.countList[0];
                accessory.form.customCount = {
                    count: spec.countList[0],
                    printingUnit: spec.printingUnit,
                };
            }

            initAccessoryCountList(accessory);
            refreshAccessoryPrice(accessory);
        }

        // ------------------------------
        // [SCOPE] 配件是否選到該數量
        // ------------------------------
        var isAccessoryCountActive = function(option, value) {

            if(option && value && option.count === value.count) {
                return true;
            }

            return false;
        }

        // ------------------------------
        // [SCOPE] 顯示配件數量文字
        // ------------------------------
        var getAccessoryCountString = function(option) {

            var text = '';

            if(option) {
                text = option.count + option.printingUnit;
            }

            return text;
        }

        // ------------------------------
        // [SCOPE] 更改配件數量
        // ------------------------------
        var onAccessoryCountChange = function(option, active, key) {

            var accessory;

            for(var i = 0; i < $scope.accessoryList.length; i++) {
                accessory = $scope.accessoryList[i];
                if(accessory.productid === key) {
                    break;
                }
                accessory = undefined;
            }

            if(!accessory) {
                return;
            }

            accessory.form[CountKey] = option.count;
            accessory.form.customCount = option;

            refreshAccessoryPrice(accessory);
        }

        // ------------------------------
        // [SCOPE] 是否選到該印刷尺寸
        // ------------------------------
        var isImageDimensionActive = function(option, imageDimension) {

            var active = option == imageDimension || 
                (option[PdtSpecProps.ImageLength] == imageDimension[PdtSpecProps.ImageLength]
                    && option[PdtSpecProps.ImageWidth] == imageDimension[PdtSpecProps.ImageWidth]
                    && option[PdtSpecProps.ImageSizeRemark] == imageDimension[PdtSpecProps.ImageSizeRemark]
            );

            return active;
        }

        // ------------------------------
        // [SCOPE] 取得印刷尺寸文字
        // ------------------------------
        var getImageDimensionString = function(option) {

            var text = '';
            var imageLength = option[PdtSpecProps.ImageLength];
            var imageWidth = option[PdtSpecProps.ImageWidth];
            var imageSizeRemark = option[PdtSpecProps.ImageSizeRemark];

            if(imageLength) {
                text += imageLength;
            }

            if(imageWidth) {

                if(text) {
                    text += ' x ';
                }

                text += imageWidth;
            }

            var specProps = $scope.spec.specProps;
            var imageSizeUnit = specProps[PdtSpecProps.ImageSizeUnit];
            var imageSizeUnitText = ProductUtil.getSizeUnitText(imageSizeUnit, true);

            if(imageSizeUnitText) {
                text = text + ' ' + imageSizeUnitText + ' ';
            }

            if(imageSizeRemark) {
                text = imageSizeRemark + '(' + text + ')';
            }

            return text;
        }

        // ------------------------------
        // [SCOPE] 取得印刷出血尺寸
        // ------------------------------
        var getImageBleedSize = function() {

            var bleedSize = '';

            if(!$scope.spec || !$scope.spec.specProps) {
                return bleedSize;
            }

            var specProps = $scope.spec.specProps;

            var imageBleedLength = isPropSupport(PdtSpecProps.ImageBleedLength) && specProps[PdtSpecProps.ImageBleedLength];
            var imageBleedWidth = isPropSupport(PdtSpecProps.ImageBleedWidth) && specProps[PdtSpecProps.ImageBleedWidth];
            var imageSizeUnit = specProps[PdtSpecProps.ImageSizeUnit];

            if(!imageBleedLength && !imageBleedWidth) {
                return bleedSize;
            }

            if(imageBleedLength > 0) {
                bleedSize += imageBleedLength;
            }

            if(imageBleedWidth > 0) {
                if(bleedSize) {
                    bleedSize += ' x ';
                }

                bleedSize += imageBleedWidth;
            }

            if(!bleedSize) {
                return bleedSize;
            }

            bleedSize = '出血尺寸：' + bleedSize + ProductUtil.getSizeUnitText(imageSizeUnit, true);

            return bleedSize;
        }

        // ------------------------------
        // [SCOPE] 取得印刷方式代碼文字
        // ------------------------------
        var getPdtPrintingTypeString = function(option) {

            var text = ProductUtil.getPdtPrintingTypeText(option);

            if(option === ProductUtil.PdtPrintingType.SCREEN_PRINTING) {
                var printingMinCount = $scope.spec.specProps[PdtSpecProps.PrintingMinCount];
                var printingUnit = $scope.spec.printingUnit;

                if(isPropSupport(PdtSpecProps.PrintingMinCount) && printingMinCount > 1) {
                    text = text + ' (' + printingMinCount + printingUnit  + '可印)';
                }
            }

            return text;
        }

        // ------------------------------
        // [SCOPE] 是否顯示設計需求
        // ------------------------------
        var showDesignRequirementList = function() {

            var specProps = $scope.spec.specProps;

            // 如果有印刷方式，要選網版印刷才會顯示
            if(isPropSupport(PdtSpecProps.PrintingTypeList) && $scope.form[PdtSpecProps.PrintingType] !== ProductUtil.PdtPrintingType.SCREEN_PRINTING) {
                return false;
            }

            return isPropSupport(PdtSpecProps.DesignRequirementList)
                && specProps[PdtSpecProps.DesignRequirementList] && specProps[PdtSpecProps.DesignRequirementList].length > 0;
        }

        // ------------------------------
        // 兩個衣服尺寸是否相等
        // ------------------------------
        var isClothingSizeEqual = function(clothingSizeA, clothingSizeB) {

            var isEqual = clothingSizeA == clothingSizeB || (
                clothingSizeA.clothingSizeunit == clothingSizeB.clothingSizeunit
                && (clothingSizeA.clothingSizeunit != ProductUtil.ClothingSizeUnit.CUSTOM || clothingSizeA.customSizeName == clothingSizeB.customSizeName)
            );

            return isEqual;
        }

        // ------------------------------
        // [SCOPE] 是否選到該衣服尺寸
        // ------------------------------
        var isClothingSizeActive = function(option) {

            if(!Array.isArray($scope.form[PdtSpecProps.ClothingSizeList])){
                return false;
            }

            for(var i = 0 ; i < $scope.form[PdtSpecProps.ClothingSizeList].length ; i++) {
                if(isClothingSizeEqual($scope.form[PdtSpecProps.ClothingSizeList][i], option)) {
                    return true;
                }
            }

            return false;
        }

        // ------------------------------
        // [SCOPE] 取得衣服尺寸文字
        // ------------------------------
        var getClothingSizeString = function(option) {

            var text = '';

            if(!option) {
                return text;
            }

            if(option.clothingSizeunit == ProductUtil.ClothingSizeUnit.CUSTOM) {
                text = text + option.customSizeName;
            } else if(option.clothingSizeunit) {
                text = text + ProductUtil.getClothingSizeUnitText(option.clothingSizeunit);
            }

            // if(option.remark) {
            //     text = text + '(' + option.remark + ')';
            // }

            return text;
        }

        // ------------------------------
        // [SCOPE] 當衣服尺寸更改時
        // ------------------------------
        var onClothingSizeChange = function(option, active, key) {

            toggleClothingSize(option);

            refreshPrice();
        }

        // ------------------------------
        // 選取／取消 衣服尺寸項目
        // ------------------------------
        var toggleClothingSize = function(_clothingSize) {

            if(!Array.isArray($scope.form[PdtSpecProps.ClothingSizeList])){
                $scope.form[PdtSpecProps.ClothingSizeList] = [];
                $scope.form[PdtSpecProps.ClothingSizeList].push(_clothingSize);
                return;
            }

            for(var i = 0 ; i < $scope.form[PdtSpecProps.ClothingSizeList].length ; i++) {
                var option = $scope.form[PdtSpecProps.ClothingSizeList][i];

                if(isClothingSizeEqual(option, _clothingSize)) {
                    $scope.form[PdtSpecProps.ClothingSizeList].remove(i);
                    return;
                }
            }

            $scope.form[PdtSpecProps.ClothingSizeList].push(_clothingSize);
        }

        // ------------------------------
        // [SCOPE] 衣服尺寸數量更動時
        // ------------------------------
        var onClothingSizeCountChange = function(clothingSize) {
            
            var min = 0;

            if(isNaN(clothingSize.count) || clothingSize.count < min) {
                clothingSize.count = min;
            }

            refreshPrice();
        }

        // ------------------------------
        // [SCOPE] 是否選到該印刷範圍
        // ------------------------------
        var isPrintingAreaActive = function(option) {

            if(!Array.isArray($scope.form[PdtSpecProps.PrintingAreaList])){
                return false;
            }

            for(var i = 0 ; i < $scope.form[PdtSpecProps.PrintingAreaList].length ; i++) {
                if($scope.form[PdtSpecProps.PrintingAreaList][i].name == option.name) {
                    return true;
                }
            }

            return false;
        }

        // ------------------------------
        // [SCOPE] 取得印刷範圍文字
        // ------------------------------
        var getPrintingAreaString = function(option) {

            var text = option.name;

            return text;
        }

        // ------------------------------
        // [SCOPE] 當印刷範圍更改時
        // ------------------------------
        var onPrintingAreaChange = function(option, active, key) {

            togglePrintingArea(option);
            
            checkPrintingArea();
        }

        // ------------------------------
        // [SCOPE] 檢查印刷範圍數值
        // ------------------------------
        var checkPrintingArea = function() {
            
            var printingAreaList = $scope.form[PdtSpecProps.PrintingAreaList];
            
            $scope.isPrintingAreaError = false;

            if(!Array.isArray(printingAreaList) || printingAreaList.length === 0){
                return;
            }

            for(var i = 0 ; i < printingAreaList.length ; i++) {
                var printingArea = printingAreaList[i];
                // var minLength = printingArea.minLength;
                // var maxLength = printingArea.maxLength;
                var minWidth = printingArea.minWidth;
                var maxWidth = printingArea.maxWidth;
                var minHeight = printingArea.minHeight;
                var maxHeight = printingArea.maxHeight;

                // if(isNaN(printingArea.length) || printingArea.length == 0) {
                //     printingArea.length = minLength;
                // }

                if(isNaN(printingArea.width) || printingArea.width == 0) {
                    printingArea.width = minWidth;
                }

                if(isNaN(printingArea.height) || printingArea.height == 0) {
                    printingArea.height = minHeight;
                }

                // var length = printingArea.length;
                var width = printingArea.width;
                var height = printingArea.height;

                printingArea.isPrintingAreaError = false;
                
                if(
                    // length < minLength || length > maxLength
                    width < minWidth || width > maxWidth
                    || height < minHeight || height > maxHeight
                ) {
                    printingArea.isPrintingAreaError = true;
                    $scope.isPrintingAreaError = true;
                }
            }
        }

        // ------------------------------
        // 選取／取消 印刷範圍項目
        // ------------------------------
        var togglePrintingArea = function(_printingArea) {

            if(!Array.isArray($scope.form[PdtSpecProps.PrintingAreaList])){
                $scope.form[PdtSpecProps.PrintingAreaList] = [];
                $scope.form[PdtSpecProps.PrintingAreaList].push(_printingArea);
                return;
            }

            for(var i = 0 ; i < $scope.form[PdtSpecProps.PrintingAreaList].length ; i++) {
                var option = $scope.form[PdtSpecProps.PrintingAreaList][i];

                if(option.name == _printingArea.name) {
                    $scope.form[PdtSpecProps.PrintingAreaList].remove(i);
                    return;
                }
            }

            $scope.form[PdtSpecProps.PrintingAreaList].push(_printingArea);
        }

        // ------------------------------
        // [SCOPE] 是否選到該印刷顏色數量
        // ------------------------------
        var isPrintingColorCountActive = function(option, printingColorCount) {

            var active = option == printingColorCount || (option.name == printingColorCount.name);

            return active;
        }

        // ------------------------------
        // [SCOPE] 取得印刷顏色數量文字
        // ------------------------------
        var getPrintingColorCountString = function(option) {

            var text = option.name;

            if(text) {
                text += '色';
            }

            return text;
        }

        // ------------------------------
        // [SCOPE] 取得是否急件文字
        // ------------------------------
        var getIsEmergencyString = function(option) {

            var text = '';

            if(option) {
                text = '是';
            } else {
                text = '否';
            }

            return text;
        }

        // ------------------------------
        // [SCOPE] 選擇的規格是否有誤
        // ------------------------------
        var isOrderItemSpecError = function() {

            return $scope.isClothinghSizeCountError || $scope.isPrintingAreaError || $scope.isLowerPrintingMinCountError || $scope.isSpecError;
        }

        // ------------------------------
        // [SCOPE] 選擇的規格錯誤時的顯示文案
        // ------------------------------
        var getOrderItemSpecErrorText = function() {

            if($scope.isPrintingAreaError) {
                return '請輸入正確的尺寸';
            }

            if($scope.isClothinghSizeCountError) {
                return '請設定衣服尺寸件數';
            }

            if($scope.isLowerPrintingMinCountError) {
                return '未達印刷最低數量';
            }

            if($scope.isSpecError) {
                return '請輸入正確的格式';
            }

            return '';
        }

        // ------------------------------
        // [SCOPE] 是否選到該可印刷幾處
        // ------------------------------
        var isPrintingPathCountActive = function(option, value) {
            
            var active = option == value || (option && value && option.pathCount == value.pathCount);

            return active;
        }
        
        // ------------------------------
        // [SCOPE] 取得可印刷幾處文字
        // ------------------------------
        var getPrintingPathCountString = function(option) {

            var text = '';

            if(!option) {
                text = '不印';
            } else if(option.pathCount > 0) {
                text = '印' + option.pathCount + '處';
            }

            return text;
        }

        //==========================
        //  Variable
        //==========================
        $scope.spec = undefined; // 目前選擇的spec
        $scope.specMatrix = []; // 規格索引矩陣
        $scope.productMap = {}; // 商品Map
        $scope.specMap = {}; // 規格Map {productid: {specid: value}}
        $scope.price = 0; // 價錢
        $scope.selectListMap = {}; // 各個欄位列表
        $scope.processPrice = 0;
        $scope.processPriceCost = undefined;
        $scope.isAddingToShoppingCart = false;
        $scope.accessoryList = [];
        $scope.specAdditionalPrice = 0;
        $scope.isClothinghSizeCountError = false;
        $scope.isPrintingAreaError = false;
        $scope.isLowerPrintingMinCountError = false;
        $scope.isSpecError = false;

        // select用object
        $scope.form = {
            // 有建立索引的欄位 @see SpecPropsIndex
            [DimensionKey]: undefined, // 選擇的長, 寬, 高
            [PdtSpecProps.PdtStyle]: undefined, // 選擇的樣式
            [PdtSpecProps.MaterialType]: undefined, // 選擇的材質
            [PdtSpecProps.Version]: undefined, // 選擇的版型
            [PdtSpecProps.AreaRange]: undefined, // 選擇的面積範圍
            [PdtSpecProps.Thickness]: undefined, // 選擇的厚度
            [PdtSpecProps.Volume]: undefined, // 選擇的容量
            [PdtSpecProps.Dpi]: undefined, // 選擇的解析度
            [PdtSpecProps.Bronzing]: undefined, // 選擇的燙金
            [PdtSpecProps.SleeveLength]: undefined, // 選擇的袖長
            [PdtSpecProps.ColorHex]: undefined, // 選擇的袖長
            // 其他 specProps 欄位
            [PdtSpecProps.IsOneSide]: undefined, // 選擇單面
            [PdtSpecProps.IsTwoSide]: undefined, // 選擇雙面
            [PdtSpecProps.DesignRequirement]: undefined, // 設計需求
            [PdtSpecProps.PrintingType]: undefined, // 印刷方式
            [PdtSpecProps.ClothingSizeList]: undefined, // 選擇的衣服尺寸與件數
            [PdtSpecProps.PrintingAreaList]: [], // 選擇的印刷範圍
            [PdtSpecProps.PrintingColorCount]: undefined, // 選擇印刷顏色數量
            [PdtSpecProps.IsEmergency]: false, // 是否急件
            [PdtSpecProps.PrintingPathCount]: undefined, // 可印刷幾處
            [PdtSpecProps.RollingColorHex]: undefined, // 滾邊色
            
            // 其他重要欄位
            [CountKey]: undefined, // 選擇的數量
            [OneTwoSideKey]: undefined, // 選擇單面還雙面
            [ProcessKey]: [], // 選擇的加工
            [OfferProcessKey]: [], // 選擇的特殊加工

            // 其他不需特別記錄key的欄位
            processRemark: undefined, // 加工備註
            userRemark: undefined, // 使用者備註說明
            supplier: undefined, // 選擇的供應商
            otherDeliveryTime: 0, // 規格和加工所耗時間
            countSelectType: CountLayoutType.Options, // 數量顯示樣式
        };

        // 變數
        $scope.PdtSpecProps = PdtSpecProps;
        $scope.ProductidKey = ProductidKey;
        $scope.SpecidKey = SpecidKey;
        $scope.DimensionKey = DimensionKey;
        $scope.CountKey = CountKey;
        $scope.OneTwoSideKey = OneTwoSideKey;
        $scope.ProcessKey = ProcessKey;
        $scope.OfferProcessKey = OfferProcessKey;
        $scope.ProductDeliveryType = ProductUtil.ProductDeliveryType; // 商品配送類型
        $scope.PdtPrintingType = ProductUtil.PdtPrintingType; // 商品配送類型
        $scope.CountLayoutType = CountLayoutType; // 數量顯示樣式

        //==========================
        //  Methods
        //==========================
        $scope.isPropSupport = isPropSupport; // 是否提供該規格
        $scope.getSizeUnit = getSizeUnit; // 尺寸單位
        $scope.getSizeUnitByInt = getSizeUnitByInt; // 尺寸單位
        $scope.getPlatemakingString = getPlatemakingString; // 取得開版日
        $scope.getBleedSize = getBleedSize; // 取得出血尺寸
        $scope.onFormValueChange = onFormValueChange; // 當選項值更改時
        $scope.isDimensionActive = isDimensionActive; // 是否選到該尺寸
        $scope.getDimensionString = getDimensionString; // 取得尺寸文字
        $scope.getDpiString = getDpiString; // 取得解析度文字
        $scope.isAreaRangeActive = isAreaRangeActive; // 是否選到該面積
        $scope.getAreaRangeHtmlString = getAreaRangeHtmlString; // 取得面積文字
        $scope.getThicknessString = getThicknessString; // 取得厚度文字
        $scope.getVolumeString = getVolumeString; // 取得容量文字
        $scope.onFreeSizeChange = onFreeSizeChange; // 當自定義尺寸更動時
        $scope.isBronzingActive = isBronzingActive; // 是否選到該燙金
        $scope.getBronzingString = getBronzingString; // 取得燙金文字
        $scope.getSideString = getSideString; // 取得單雙面文字
        $scope.onSideChange = onSideChange; // 單雙面更動時
        $scope.getCountString = getCountString; // 取得數量文字
        $scope.onNumberValueChange = onNumberValueChange; // 數字資料更動時
        $scope.increaseCount = increaseCount; // 數量加1
        $scope.decreaseCount = decreaseCount; // 數量減1
        $scope.isColorActive = isColorActive; // 是否選到該顏色
        $scope.getColorHtmlString = getColorHtmlString; // 取得顏色文字
        $scope.getColorHtmlBlock = getColorHtmlBlock; // 取得顏色方塊
        $scope.getMobileColorHtmlBlock = getMobileColorHtmlBlock; // 取得手機版顏色方塊
        $scope.isProcessActive = isProcessActive; // 是否選到該加工
        $scope.getProcessString = getProcessString; // 取得加工文字
        $scope.onProcessChange = onProcessChange; // 當加工更改時
        $scope.isOfferProcessActive = isOfferProcessActive; // 是否選到該特殊加工
        $scope.getOfferProcessString = getOfferProcessString; // 取得特殊加工文字        
        $scope.onOfferProcessChange = onOfferProcessChange; // 當特殊加工更改時        
        $scope.checkSelectedProcess = checkSelectedProcess; // 檢查是否有勾選加工項目
        $scope.checkSelectedOfferProcess = checkSelectedOfferProcess; // 檢查是否有勾選特殊加工項目
        $scope.getDesignRequirementString = getDesignRequirementString; // 取得設計需求文字
        $scope.getViewPrice = getViewPrice; // 取得顯示畫面面上的價格
        $scope.getViewPriceRemark = getViewPriceRemark; // 取得顯示畫面面上價格備註
        $scope.closeQuickOrder = closeQuickOrder; // 關閉快速下單modal
        $scope.toggleAccessorySelected = toggleAccessorySelected; // 選擇配件
        $scope.getAccessoryImage = getAccessoryImage; // 取得配件圖片
        $scope.showAccessoryImage = showAccessoryImage; // 顯示配件圖片
        $scope.isAccessorySpecActive = isAccessorySpecActive; // 是否選到該配件
        $scope.getAccessorySpecString = getAccessorySpecString; // 顯示配件規格名稱，目前為顯示樣式
        $scope.onAccessorySpecChange = onAccessorySpecChange; // 選擇配件規格
        $scope.isAccessoryCountActive = isAccessoryCountActive; // 配件是否選到該數量
        $scope.getAccessoryCountString = getAccessoryCountString; // 顯示配件數量文字
        $scope.onAccessoryCountChange = onAccessoryCountChange; // 更改配件數量
        $scope.isImageDimensionActive = isImageDimensionActive; // 是否選到該印刷尺寸
        $scope.getImageDimensionString = getImageDimensionString; // 取得印刷尺寸文字
        $scope.getImageBleedSize = getImageBleedSize; // 取得印刷出血尺寸
        $scope.getPdtPrintingTypeString = getPdtPrintingTypeString; // 取得印刷方式代碼文字
        $scope.showDesignRequirementList = showDesignRequirementList; // 是否顯示設計需求
        $scope.isClothingSizeActive = isClothingSizeActive; // 是否選到該衣服尺寸
        $scope.getClothingSizeString = getClothingSizeString; // 取得衣服尺寸文字
        $scope.onClothingSizeChange = onClothingSizeChange; // 當衣服尺寸更改時
        $scope.onClothingSizeCountChange = onClothingSizeCountChange; // 衣服尺寸數量更動時
        $scope.isPrintingAreaActive = isPrintingAreaActive; // 是否選到該印刷範圍
        $scope.getPrintingAreaString = getPrintingAreaString; // 取得印刷範圍文字
        $scope.onPrintingAreaChange = onPrintingAreaChange; // 當印刷範圍更改時
        $scope.checkPrintingArea = checkPrintingArea; // 檢查印刷範圍數值
        $scope.isPrintingColorCountActive = isPrintingColorCountActive; // 是否選到該印刷顏色數量
        $scope.getPrintingColorCountString = getPrintingColorCountString; // 取得印刷顏色數量文字
        $scope.getIsEmergencyString = getIsEmergencyString; // 取得是否急件文字
        $scope.isOrderItemSpecError = isOrderItemSpecError; // 選擇的規格是否有誤
        $scope.getOrderItemSpecErrorText = getOrderItemSpecErrorText; // 選擇的規格錯誤時的顯示文案
        $scope.isPrintingPathCountActive = isPrintingPathCountActive; // 是否選到該可印刷幾處
        $scope.getPrintingPathCountString = getPrintingPathCountString; // 取得可印刷幾處文字

        /**
         *
         * [DIFFERENT] 前後台審稿行為不一樣的function / variable等等..
         * 
         */

        // -------------------------------
        // [SCOPE] 加入至購物車
        // -------------------------------
        var addToShoppingCart = function(isOpenFromFooter) {

            if(!$scope.isShowAllSepc) {
                var scrollTo = $element.find('.product-spec').position().top;
                document.body.scrollTop = document.documentElement.scrollTop = scrollTo;

                $scope.isShowAllSepc = true;
                $scope.isOpenFromFooter = isOpenFromFooter;
                return;
            }

            if($scope.isAddingToShoppingCart || isOrderItemSpecError()) {
                return;
            }

            $scope.isAddingToShoppingCart = true;

            $rootScope.$broadcast('OPEN_LOADING_MODAL', {
                title: '加入購物車中',
            });

            // 檢查加工裡有沒有燙金項目，有則多一筆版費項目
            checkProcess();

            var productid = $scope.product.productid,
                _spec = convertFormToOrderItemSpec($scope.spec, $scope.form, $scope.product),
                spec = _spec ? JSON.stringify(_spec) : undefined,
                processRemark = undefined,
                addCount = 1,
                userRemark = $scope.form.userRemark,
                supplier = $scope.form.supplier;

            if(checkSelectedProcess()) {
                processRemark = $scope.form.processRemark;
            }

            var queues = [];

            queues.push(getAddToShoppingCartQueue(productid, spec, addCount, processRemark, userRemark, supplier));

            if($scope.accessoryList.length > 0) {
                for(var p = 0; p < $scope.accessoryList.length; p++) {
                    var accessory = $scope.accessoryList[p];

                    if(accessory.isAccessorySelected) {
                        
                        productid = accessory.productid,
                        _spec = convertFormToOrderItemSpec(accessory.spec, accessory.form, accessory),
                        spec = _spec ? JSON.stringify(_spec) : undefined,
                        processRemark = undefined,
                        addCount = 1,
                        userRemark = undefined,
                        supplier = accessory.form.supplier;

                        queues.push(getAddToShoppingCartQueue(productid, spec, addCount, processRemark, userRemark, supplier));
                    }
                }
            }

            var runQueue = function(index) {

                if(index >= queues.length) {

                    $scope.form[ProcessKey].length = 0;
                    $scope.form[OfferProcessKey].length = 0;
                    $scope.form.processRemark = undefined;
                    $scope.form.userRemark = undefined;
                    $scope.isAddingToShoppingCart = false;

                    $rootScope.$broadcast('CLOSE_LOADING_MODAL');
                    $rootScope.$broadcast('OPEN_ADD_CART_RESULT_MODAL');

                    $element.parents('.scroll-content').scrollTop(0);

                    sendAddItemToCartGA();

                    return;
                }

                var queue = queues[index];
                
                queue().then(function(result) {
                    runQueue(index + 1);
                }, function(error) {
                    $scope.isAddingToShoppingCart = false;

                    $rootScope.$broadcast('OPEN_LOADING_ERROR_MODAL', {
                        title: '系統發生錯誤',
                    });
                });
            };

            runQueue(0);
        }

        // -------------------------------
        // 加入至購物車 Queue
        // -------------------------------
        var getAddToShoppingCartQueue = function(productid, spec, addCount, processRemark, userRemark, supplier) {

            var queue = function() {

                var defer = $q.defer();

                ShoppingCartService.addProductToShoppingCart(productid, spec, addCount, processRemark, userRemark, supplier).then(function(result) {
                    defer.resolve(true);
                }, function(error) {
                    defer.reject(error);
                });

                return defer.promise;
            }

            return queue;
        }

        // -------------------------------
        // [SCOPE] 更改商品
        // -------------------------------
        var changeOrderitem = function() {

            if(isOrderItemSpecError()) {
                return;
            }

            // 檢查加工裡有沒有燙金項目，有則多一筆版費項目
            checkProcess();

            var processRemark = undefined,
                _spec = convertFormToOrderItemSpec($scope.spec, $scope.form, $scope.product),
                spec = _spec ? JSON.stringify(_spec) : undefined;

            if(checkSelectedProcess()) {
                processRemark = $scope.form.processRemark;
            }

            $rootScope.$broadcast("ON_CHANGE_ORDERITEM_SUCCESS", {
                product: $scope.product,
                spec: spec,
                processRemark: processRemark,
                supplier: $scope.form.supplier,
            });
        }

        // -------------------------------
        // [SCOPE] 呈現所有規格
        // -------------------------------
        var showAllSpec = function() {

            $scope.isShowAllSepc = true;
        }

        // -------------------------------
        // 發送 ga
        // -------------------------------
        var sendAddItemToCartGA = function() {

            var ga_info = {
                productid: $scope.product.productid,
                name: $scope.product.name,
                mrscid: (UserService.user && UserService.user.mrscid) ? UserService.user.mrscid : 'visitor',
                pdtclass: $scope.product.pdtClass,
                pdtClassName: $scope.product.pdtClassName,
            }

            $InifECGA.sendAddItemToCartGA(ga_info);
        }

        // --------------------------------
        // 切換複合商品
        // -------------------------------
        var changeComplexPdt = function(complexPdt) {

            var _product = shallowCopy($scope.product);

            complexPdt.name = _product.name;
            complexPdt.complex = _product.complex;
            complexPdt.isComplex = _product.isComplex;

            // compile note html
            var $raw = $('<div/>').html(complexPdt.pdtContent);
            $raw.find('img').each(function(){
                var src = $(this).attr('src');
                if(src && src.startsWith("//") && location.protocol.startsWith("file")){
                    this.src = "http:" + src;
                }
            });

            complexPdt.pdtContent = $raw.prop('innerHTML');

            $scope.product = complexPdt;
            $scope.isChangeComplex = true;

            $timeout(function() {
                $scope.isChangeComplex = false;
            });
            
            // init();
            filterSpec();
        }

        // -------------------------------
        // [SCOPE] 選擇配件
        // -------------------------------
        var toggleMobileAccessorySelected = function(accessory) {

            if(accessory.isAccessorySelected) {
                accessory.isAccessorySelected = false;
                refreshPrice();
                return;
            }

            $rootScope.$broadcast('OPEN_SELECT_ACCESSORY_SPEC_MODAL', {
                accessory: accessory,
                // function
                selectAccessory: function() {
                    accessory.isAccessorySelected = true;
                    refreshPrice();
                },
                getAccessoryImage: getAccessoryImage,
                isAccessorySpecActive: isAccessorySpecActive,
                getAccessorySpecString: getAccessorySpecString,
                onAccessorySpecChange: onAccessorySpecChange,
                isAccessoryCountActive: isAccessoryCountActive,
                getAccessoryCountString: getAccessoryCountString,
                onAccessoryCountChange: onAccessoryCountChange,
            });
        }
        
        // ------------------------------
        // 商品無數量時的數量列表
        // ------------------------------
        var initCustomCountList = function() {

            for(let i = 1; i <= CountMaxMultiple; i++) {
                $scope.customCountList.push(i);
            }
        }

        // -------------------------------
        // [private] 初始化
        // -------------------------------
        var init = function() {
            
            var spec = undefined;

            if($scope.orderitem) {
                spec = shallowCopy($scope.orderitem.spec);
                $scope.form.processRemark = $scope.orderitem.processRemark;
                $scope.form.userRemark = $scope.orderitem.userRemark;
            }

            if($state.current.name == window.STATES.PRODUCT || $state.current.name == window.STATES.COMPLEX_PDT) {
                spec = $stateParams.spec;

                if(spec) { 
                    spec = JSON.parse(spec);
                }
            }

            if(spec == undefined) {
                spec = {};
            }

            if($scope.product) {

                initSupplier($scope.product, $scope.form);


                if($scope.product.specs && $scope.product.specs.length > 0) {
                    // 這邊的spec都會是後端形式的資料，這邊要轉成前端可用的
                    var defaultSpecForm = convertOrderItemSpecToForm(spec);
                    initSpec(defaultSpecForm);
                }

                if($scope.product.accessoryList && $scope.product.accessoryList.length > 0) {
                    initAccessorySpec($scope.product.accessoryList);
                }
            }

            initCustomCountList();
        }

        //==========================
        //  手機 Events
        //==========================

        //==========================
        //  手機 Variables
        //==========================
        $scope.customCountList = [];
        $scope.isShowAllSepc = false;
        $scope.isChangeComplex = false;
        $scope.isOpenFromFooter = false;

        //==========================
        //  手機 Methods
        //==========================
        $scope.addToShoppingCart = addToShoppingCart; // 加入至購物車
        $scope.changeOrderitem = changeOrderitem; //更改商品
        $scope.showAllSpec = showAllSpec; //呈現所有規格
        $scope.toggleMobileAccessorySelected = toggleMobileAccessorySelected; // 選擇配件

        //==========================
        //  Init
        //==========================
        init();
        
    }
]);


window.InifECMobileApp.directive('productSpec', ['$rootScope', function($rootScope) {

    var _dir = {};

    _dir.restrict = 'AE';
    _dir.scope = {
        product: '=',
        complex: '=',
        price: '=',
        addToShoppingCart: '=',
        isShowAllSepc: '=',
        isChangeComplex: '=',
        isOpenFromFooter: '=',
        getViewPrice: '=',
        isClothinghSizeCountError: '=',
        isPrintingAreaError: '=',
        isOrderItemSpecError: '=',
    };
    _dir.templateUrl = "mobile/partials/directives/product_spec.html";
    _dir.controller = "PdtSpecController";

    return _dir;

}]);

window.InifECMobileApp.directive('changeProductSpec', ['$rootScope', function($rootScope) {

    var _dir = {};

    _dir.restrict = 'AE';
    _dir.scope = {
        product: '=',
        complex: '=',
        orderitem: '=',
        changeOrderitem: '=',
        isClothinghSizeCountError: '=',
        isPrintingAreaError: '=',
        isOrderItemSpecError: '=',
    };
    _dir.templateUrl = "mobile/partials/directives/change_product_spec.html";
    _dir.controller = "PdtSpecController";

    return _dir;

}]);
